/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-loop-func */
/* eslint-disable no-prototype-builtins */
/* eslint-disable prefer-rest-params */
import { DateTime } from 'luxon'
import { IPcr } from '../../pcr/store/pcr.types'
import { IOption, IOptionObj, IPNNVOption } from '../../../common/common.types'
import { IStateResult } from '../../nemsisData/store/nemsisCustomData.types'

interface SourceLicensureDetail {
  id: string;
  isCertType: boolean;
  type?: string;
  crewLevel?: string;
}

interface FlatOutput {
  id?: string;
  stateId?: string;
  type?: string;
}

const MMDDYYYY = /^\d{2}\/\d{2}\/\d{4}$/
export default class RulesUtilsMaster {
  public static number(jsonData: any, key: any = null, filter: any = null, customResult02Val: any = null) {
    if (jsonData === 'P') {
      return 0
    }
    else if (!key && !filter) {
      return +jsonData
    }
    else if (key) {
      if (!filter) {
        if (jsonData && Array.isArray(jsonData) && jsonData.length > 0) {
          if (key.includes('.')) {
            const keyParts = key.split('.')
            let conditionForComparison
            let valueToReturn = Number.NaN
            jsonData.forEach((data: any) => {
              if (customResult02Val) {
                conditionForComparison = (data[keyParts[0]] || data[keyParts[0]] === 0) && data.customElementName === customResult02Val
              }
              else
                conditionForComparison = (data[keyParts[0]] || data[keyParts[0]] === 0)
              if (conditionForComparison) {
                const result = data[keyParts[0]]
                const value = result[keyParts[1]]
                if (!isNaN(+value)) {
                  valueToReturn = +value
                }
              }
            })
            return valueToReturn
          }
          else {
            let conditionForComparison
            let valueToReturn = Number.NaN
            jsonData.forEach((data: any) => {
              if (customResult02Val) {
                conditionForComparison = (data[key] || data[key] === 0) && data.customElementName === customResult02Val
              }
              else
                conditionForComparison = (data[key] || data[key] === 0)
              if (conditionForComparison) {
                const value = data[key]
                if (!isNaN(+value)) {
                  valueToReturn = +value
                }
              }
            })
            return valueToReturn
          }
          //TO-DO: Logic for Key without dot(.) if required 
        }
        else if (jsonData && !Array.isArray(jsonData)) {
          const num = jsonData[key]
          return +num
        }
        else {
          //TO-DO: Logic if jsonData is not an array
          return 0
        }
      }
      //TO-DO: Filter logic if required
    }
    else {
      return 0
    }
  }

  //#MARK: copyPNNVs
  public static copyPNNVs(pcrData: any): any {
    Object.keys(this.copyPNNVValuesMap).forEach((path) => {
      const pnnvPath = this.copyPNNVValuesMap[path].pnnvPath
      pcrData = this.copyNVValueToNormalField(pcrData, path, pnnvPath, '') as IPcr
    })

    return pcrData
  }

  //#MARK: copyNVValueToNormalField
  public static copyNVValueToNormalField(jsonData: Record<any, any>, path: string, pnnvPath: string, pathPrefix: string): Record<any, any> {
    const pathSegments = path.split('.')
    const pnnvPathSegments = pnnvPath.split('.')
    let currentValue = jsonData
    let valueAtPNNVPath: IOptionObj | null = null

    // Check if datapoints PNNV field has value
    for (const [i, pnnvPathSegment] of pnnvPathSegments.entries()) {
      if (i !== pnnvPathSegments.length - 1) {
        if (currentValue.hasOwnProperty(pnnvPathSegment)) {
          currentValue = currentValue[pnnvPathSegment]

          if (Array.isArray(currentValue) && currentValue.length > 0) {
            const subPathSegments = pathSegments.slice(i + 1).join('.')
            const subPNNVPathSegments = pnnvPathSegments.slice(i + 1).join('.')
            const pnnvPrefixPath = pnnvPathSegments.slice(0, i + 1).join('.')

            currentValue.forEach((pnnvelement, idx) => {
              const pnnvCopiedElement = this.copyNVValueToNormalField(pnnvelement, subPathSegments, subPNNVPathSegments, pnnvPrefixPath)
              currentValue[idx] = pnnvCopiedElement
            })
          }
        } else {
          break
        }
      } else {
        if (
          currentValue[pnnvPathSegment] ||
          (Array.isArray(currentValue[pnnvPathSegment]) && currentValue[pnnvPathSegment].length > 0)
        ) {
          valueAtPNNVPath = currentValue[pnnvPathSegment]
        }
      }
    }

    // Nothing in PNNV field so return
    if (!valueAtPNNVPath) return jsonData
    currentValue = jsonData

    // Non-PNNV Real Field entries
    for (const [i, pathSegment] of pathSegments.entries()) {
      if (i !== pathSegments.length - 1) {
        if (currentValue.hasOwnProperty(pathSegment)) {
          currentValue = currentValue[pathSegment]
        } else {
          currentValue[pathSegment] = {}
          currentValue = currentValue[pathSegment]
        }
      } else {
        // If datapoint has value of any kind - return
        if (
          currentValue[pathSegment] != null &&
          (typeof currentValue[pathSegment] == 'number' ||
            (Array.isArray(currentValue[pathSegment]) && currentValue[pathSegment].length > 0) ||
            (typeof currentValue[pathSegment] == 'string' && currentValue[pathSegment] != '') ||
            (typeof currentValue[pathSegment] == 'object' && Object.entries(currentValue[pathSegment]).length > 0))
        ) {
          return jsonData
        }

        // Determine value type expected for real field
        const fieldType = Object.keys(this.copyPNNVValuesMap).includes(pathPrefix ? [pathPrefix, path].join('.') : path) ?
          this.copyPNNVValuesMap[pathPrefix ? [pathPrefix, path].join('.') : path].fieldType : typeof currentValue[pathSegment]

        // Array of IOptions
        if (fieldType == 'array') {
          currentValue[pathSegment] = []
          currentValue[pathSegment].push(valueAtPNNVPath)

          // TODO: Address different array item types

          //  Non-Array non-IOption Field - like firstName
        } else if (fieldType == 'string') {
          currentValue[pathSegment] = valueAtPNNVPath.name

          // Non-Array IOption field - like gender
        } else if (fieldType == 'object') {
          const objValue: IOptionObj = {
            id: valueAtPNNVPath.id,
            name: valueAtPNNVPath.name ? valueAtPNNVPath.name : '',
            nemsisCode: Object.keys(valueAtPNNVPath).includes('nemsisCode') ? valueAtPNNVPath.nemsisCode : '',
          }

          currentValue[pathSegment] = objValue
        } else {
          // By default, set real field's value to whatever is at PNNV counterpart
          currentValue[pathSegment] = valueAtPNNVPath
        }
      }
    }
    return jsonData
  }

  public static copyPNNVValuesMap: Record<string, any> = {
    'disposition.reasonForChoosingDestination': {
      pnnvPath: 'disposition.reasonForChoosingDestinationPNNV',
      fieldType: 'array',
    },
    'patient.patientDemographics.barriersToCare': {
      pnnvPath: 'patient.patientDemographics.barriersToCarePNNV',
      fieldType: 'array',
    },
    'patient.patientDemographics.dnr': { pnnvPath: 'patient.patientDemographics.dnrPNNV', fieldType: 'array' },
    'patient.patientDemographics.gender': { pnnvPath: 'patient.patientDemographics.genderPNNV', fieldType: 'object' },
    'billing.authorizationInformation.reasonForInterfacilityTransfer': {
      pnnvPath: 'billing.authorizationInformation.reasonForInterfacilityTransferPNNV',
      fieldType: 'object',
    },
    'billing.paymentInformation.primaryMethodOfPayment': {
      pnnvPath: 'billing.paymentInformation.primaryMethodOfPaymentPNNV',
      fieldType: 'object',
    },
    'disposition.hospitalCapability': { pnnvPath: 'disposition.hospitalCapabilityPNNV', fieldType: 'array' },
    'disposition.addlTransportModeDescriptors': { pnnvPath: 'disposition.addlTransportModeDescriptorsPNNV', fieldType: 'array' },
    'disposition.transportModeFromScene': { pnnvPath: 'disposition.transportModeFromScenePNNV', fieldType: 'object' },
    'patient.tripInformation.emdPerformed': { pnnvPath: 'patient.tripInformation.emdPerformedPNNV', fieldType: 'object' },
    'patient.tripInformation.massCasualty': { pnnvPath: 'patient.tripInformation.massCasualtyPNNV', fieldType: 'object' },
    'patient.tripInformation.patientEvaluation': { pnnvPath: 'patient.tripInformation.patientEvaluationPNNV', fieldType: 'object' },
    'patient.tripInformation.crewDisposition': { pnnvPath: 'patient.tripInformation.crewDispositionPNNV', fieldType: 'object' },
    'patient.tripInformation.transportDisposition': { pnnvPath: 'patient.tripInformation.transportDispositionPNNV', fieldType: 'object' },
    'prAssess.thromScreen': { pnnvPath: 'prAssess.thromScreenPNNV', fieldType: 'object' },
    'prNabc.strokeCvaSymptomsResolved': { pnnvPath: 'prNabc.strokeCvaSymptomsResolvedPNNV', fieldType: 'object' },
    'prNabc.strokeScale': { pnnvPath: 'prNabc.strokeScalePNNV', fieldType: 'object' },
    'prGcsQualifier': { pnnvPath: 'prGcsQualifierPNNV', fieldType: 'object' },
    'prNabc.broselow': { pnnvPath: 'prNabc.broselowPNNV', fieldType: 'object' },
    'sceneDescription.levelCarePerProtocol': { pnnvPath: 'sceneDescription.levelCarePerProtocolPNNV', fieldType: 'object' },
    'sceneDescription.firstOnScene': { pnnvPath: 'sceneDescription.firstOnScenePNNV', fieldType: 'object' },
    'patient.pickupAddress.modeDescriptors': { pnnvPath: 'patient.pickupAddress.modeDescriptorsPNNV', fieldType: 'array' },
    'ccHpiCardiacArrest.arrestPresent': { pnnvPath: 'ccHpiCardiacArrest.arrestPresentPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.etiology': { pnnvPath: 'ccHpiCardiacArrest.etiologyPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.initialRhythm': { pnnvPath: 'ccHpiCardiacArrest.initialRhythmPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.firstCpr': { pnnvPath: 'ccHpiCardiacArrest.firstCprPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.firstAedBy': { pnnvPath: 'ccHpiCardiacArrest.firstAedByPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.defibBy': { pnnvPath: 'ccHpiCardiacArrest.defibByPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.discReason': { pnnvPath: 'ccHpiCardiacArrest.discReasonPNNV', fieldType: 'object' },
    'ccHpiCardiacArrest.destRhythm': { pnnvPath: 'ccHpiCardiacArrest.destRhythmPNNV', fieldType: 'array' },
    'ccHpiCardiacArrest.cprPriorEmsArrival': { pnnvPath: 'ccHpiCardiacArrest.cprPriorEmsArrivalPNNV', fieldType: 'object' },
    'diagnosis.impressions': { pnnvPath: 'diagnosis.impressionsPNNV', fieldType: 'array' },
    'diagnosis.organSystems': { pnnvPath: 'diagnosis.organSystemsPNNV', fieldType: 'array' },
    'diagnosis.anatomicLocation': { pnnvPath: 'diagnosis.anatomicLocationPNNV', fieldType: 'array' },
    'diagnosis.initialPatientAcuity': { pnnvPath: 'diagnosis.initialPatientAcuityPNNV', fieldType: 'object' },
    'diagnosis.finalPatientAcuity': { pnnvPath: 'diagnosis.finalPatientAcuityPNNV', fieldType: 'object' },
    'exposure.exposureList.exposureType': { pnnvPath: 'exposure.exposureList.exposureTypePNNV', fieldType: 'array' },
    'exposure.exposureList.suspectedExposure': { pnnvPath: 'exposure.exposureList.suspectedExposurePNNV', fieldType: 'object' },
    'patient.patientVitals.bloodPressureMethod': { pnnvPath: 'patient.patientVitals.bloodPressureMethodPNNV', fieldType: 'object' },
    'patient.patientVitals.gcsQualifier': { pnnvPath: 'patient.patientVitals.gcsQualifierPNNV', fieldType: 'array' },
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.doseUnit': { pnnvPath: 'patient.medicationAdministeredStateList.addMedicationAdministeredData.doseUnitPNNV', fieldType: 'object' },
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.route': { pnnvPath: 'patient.medicationAdministeredStateList.addMedicationAdministeredData.routePNNV', fieldType: 'object' },
    'patient.medicationAdministeredStateList.administeredByAnotherUnit': { pnnvPath: 'patient.medicationAdministeredStateList.administeredByAnotherUnitPNNV', fieldType: 'object' },
    'patient.wastedMedicationsList.doseUnit': { pnnvPath: 'patient.wastedMedicationsList.doseUnitPNNV', fieldType: 'object' },
    'factorsAffectingCareState.dispatchFactors': { pnnvPath: 'factorsAffectingCareState.dispatchFactorsPNNV', fieldType: 'array' },
    'factorsAffectingCareState.turnAroundFactors': { pnnvPath: 'factorsAffectingCareState.turnAroundFactorsPNNV', fieldType: 'array' },
    'factorsAffectingCareState.transportFactors': { pnnvPath: 'factorsAffectingCareState.transportFactorsPNNV', fieldType: 'array' },
    'factorsAffectingCareState.sceneFactors': { pnnvPath: 'factorsAffectingCareState.sceneFactorsPNNV', fieldType: 'array' },
    'factorsAffectingCareState.responseFactors': { pnnvPath: 'factorsAffectingCareState.responseFactorsPNNV', fieldType: 'array' },
    'ccHpiInjuryDetails.workrelated': { pnnvPath: 'ccHpiInjuryDetails.workrelatedPNNV', fieldType: 'object' },
    'ccHpiInjuryDetails.traumaTriageCriteriaModerateRisk': { pnnvPath: 'ccHpiInjuryDetails.traumaTriageCriteriaModerateRiskPNNV', fieldType: 'array' },
    'ccHpiInjuryDetails.traumaTriageCriteriaHighRisk': { pnnvPath: 'ccHpiInjuryDetails.traumaTriageCriteriaHighRiskPNNV', fieldType: 'array' },
    'ccHpiInjuryDetails.mechanism': { pnnvPath: 'ccHpiInjuryDetails.mechanismPNNV', fieldType: 'array' },
    'ccHpiInjuryDetails.safetyEquipment': { pnnvPath: 'ccHpiInjuryDetails.safetyEquipmentPNNV', fieldType: 'array' },
    'crew.roles': { pnnvPath: 'crew.rolesPNNV', fieldType: 'array' },
    'additionalAssessment.obstetrics.isPatientPregnant': { pnnvPath: 'additionalAssessment.obstetrics.isPatientPregnantPNNV', fieldType: 'object' },
    'patient.allCombinedProcedures.response': { pnnvPath: 'patient.allCombinedProcedures.responsePNNV', fieldType: 'object' },
    'patient.allCombinedProcedures.rolePerforming': { pnnvPath: 'patient.allCombinedProcedures.rolePerformingPNNV', fieldType: 'object' },
    'patient.allCombinedProcedures.procedurePerformedByAnotherUnit': { pnnvPath: 'patient.allCombinedProcedures.procedurePerformedByAnotherUnitPNNV', fieldType: 'object' },
    'patient.titrateStateList.route': { pnnvPath: 'patient.titrateStateList.routePNNV', fieldType: 'object' },
    'patient.titrateStateList.rate': { pnnvPath: 'patient.titrateStateList.ratePNNV', fieldType: 'object' },
    'patient.initiateIvStateList.site': { pnnvPath: 'patient.initiateIvStateList.sitePNNV', fieldType: 'object' },
    'sceneDescription.otherAgencies.firstOnScene': { pnnvPath: 'sceneDescription.otherAgencies.firstOnScenePNNV', fieldType: 'object' },
    'sceneDescription.transferOfCare': { pnnvPath: 'sceneDescription.transferOfCarePNNV', fieldType: 'object'},
    'patient.patientDemographics.altHomeResidence': { pnnvPath: "patient.patientDemographics.altHomeResidencePNNV", fieldType: "object" }
  }

  //#region for Schematron Pre-Run Rules Functions (e.g. PNNV autofill)

  public static autofillPNNVs(pcrData: IPcr): IPcr {
    const notValuesMap = { ...this.notValuesMapSingleFrequency, ...this.notValuesMapMultipleFrequency }

    Object.keys(notValuesMap).forEach((path) => {
      const pnnvPath = notValuesMap[path]
      pcrData = this.autofillField(pcrData, path, pnnvPath) as IPcr
    })
    this.setupPNNVForImpressions(pcrData)
    this.setupPNNVForSymptoms(pcrData)
    return pcrData
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static autofillField(jsonData: Record<any, any>, path: string, pnnvPath: string): Record<any, any> {
    const pathSegments = path.split('.')
    const pnnvPathSegments = pnnvPath.split('.')
    let currentValue = jsonData
    let valueAtPath = false

    const isMultipleFrequencyPath = Object.keys(this.notValuesMapMultipleFrequency).includes(path)
    let isMultipleFrequencyField = false
    if (jsonData.patient) {
      if (!jsonData.patient.patientVitals || jsonData.patient.patientVitals.length === 0) {
        jsonData.patient.patientVitals = [{}]
      }
      const isMedicationListEmptyOrNotPresent = !jsonData.patient.medicationAdministeredStateList || jsonData.patient.medicationAdministeredStateList.length === 0
      const isPNNVsListEmptyOrNotPresent = !jsonData.patient.medicationAdministeredStateListPNNVs || jsonData.patient.medicationAdministeredStateListPNNVs.length === 0
      if (isMedicationListEmptyOrNotPresent && isPNNVsListEmptyOrNotPresent) {
        // If both conditions are met, set medicationAdministeredStateList to an array with an empty object
        jsonData.patient.medicationAdministeredStateList = [{ addMedicationAdministeredData: [{}] }]
      }
    }

    if (jsonData.disposition && jsonData.disposition.destination && !jsonData.disposition.destination.txToCode) {
      const objValue: IOption = {
        id: undefined,
        name: '',
        nemsisCodeRef: '',
      }
      jsonData.disposition.destination.txToCode = objValue
    }

    // Check if field is empty
    for (const [i, pathSegment] of pathSegments.entries()) {
      if (i !== pathSegments.length - 1) {
        if (pathSegment != null && currentValue.hasOwnProperty(pathSegment)) {
          currentValue = currentValue[pathSegment]

          // If we reach an array, iterate over its elements,
          // recursively calling the autofill function for each element
          // to supply them with PNNVs
          if (Array.isArray(currentValue) && currentValue.length > 0) {
            isMultipleFrequencyField = true
            const subPathSegments = pathSegments.slice(i + 1).join('.')
            const subPNNVPathSegments = pnnvPathSegments.slice(i + 1).join('.')

            currentValue.forEach((element, i) => {
              const autofilledElement = this.autofillField(element, subPathSegments, subPNNVPathSegments)
              currentValue[i] = autofilledElement
            })
          }
        } else {
          break
        }
      } else {
        if (currentValue.hasOwnProperty(pathSegment)) {
          if (Array.isArray(currentValue[pathSegment])) {
            valueAtPath = currentValue[pathSegment].length > 0
          } else {
            if(currentValue[pathSegment] !== undefined && typeof currentValue[pathSegment] === 'boolean'){
              valueAtPath = true
            }
            else {
              valueAtPath = !!currentValue[pathSegment]
            }
          }
        }
      }
    }
    if (valueAtPath || isMultipleFrequencyField) return jsonData

    // If field is empty, add a "Not Recorded" value
    currentValue = jsonData
    const notRecordedOption: IPNNVOption = {
      id: 7701003,
      name: 'Not Recorded',
      nv: '7701003',
      pn: '',
    }

    for (const [i, pathSegment] of pnnvPathSegments.entries()) {
      if (i !== pathSegments.length - 1) {
        if (currentValue.hasOwnProperty(pathSegment)) {
          currentValue = currentValue[pathSegment]
        } else if (!isMultipleFrequencyPath) {
          currentValue[pathSegment] = {}
          currentValue = currentValue[pathSegment]
        } else {
          break
        }
      } else {
        if (
          !currentValue[pathSegment] ||
          (Array.isArray(currentValue[pathSegment]) && currentValue[pathSegment].length === 0)
        ) {
          currentValue[pathSegment] = notRecordedOption
        }
      }
    }

    return jsonData
  }

  /* 
      PNNVs for Impressions requires more data transformation\addition to get it in shape that helps 
      to run schematron rules correctly.
      This function will add an array object "impressionsPNNV", under data.diagnosis and will contain one or 
      two array items with Not Value setup for Primary and\or Secondary impression based on user selection that 
      might already be available under data.diagnosis.impressions and data.diagnosis.impressionsPNNV.
      Note: data.diagnosis section is expected to be available in the temp PCR when this method gets executed as this section will
      get added to temp PCR when autofillPNNVs got executed, even if source PCR did not have this section
  */
  public static setupPNNVForImpressions(data: any): any {
    const NOT_RECORDED = {
      id: 7701003,
      name: 'Not Recorded',
      nv: '7701003',
      pn: '',
    }
    if (!data.diagnosis.impressions) {
      data.diagnosis.impressions = []
    }
    if (!data.diagnosis.impressionsPNNV) {
      data.diagnosis.impressionsPNNV = []
    } else {
      const originalImpressionsPNNV = data.diagnosis.impressionsPNNV
      data.diagnosis.impressionsPNNV = [originalImpressionsPNNV]
    }
    const impressionsPNNV: any[] = []
    const userImpressionsPNNVData = data.diagnosis.impressionsPNNV
    const userImpressionsPNNVCount = data.diagnosis.impressionsPNNV.length
    const userImpressionsCount = data.diagnosis.impressions.length

    const findImpressionBySegmentId = (impressions :any, id :number) => {
      let found = false
      impressions.forEach( (impression :any) => {
        const impressionSegmentId = impression.segmentId
        if (impressionSegmentId === id) {
          found = true
        }
      })
      return found
    }

    if (userImpressionsCount > 0 && userImpressionsPNNVCount === 0) {
      const hasPrimaryImpression = findImpressionBySegmentId(data.diagnosis.impressions, 1)
      const hasSecondaryImpression = findImpressionBySegmentId(data.diagnosis.impressions, 2)

      if (!hasPrimaryImpression) {
        impressionsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 1,
        })
      }
      if (!hasSecondaryImpression) {
        impressionsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 2,
        })
      }

      data.diagnosis.impressionsPNNV = impressionsPNNV
      return data
    }

    if (userImpressionsCount === 2) {
      if (userImpressionsPNNVCount === 0) {
        return data
      } else {
        data.diagnosis.impressionsPNNV = []
      }
    } else if (userImpressionsCount === 1) {
      if (userImpressionsPNNVCount === 1) {
        return data
      } else {
        // Impression count being 1, Primary Impression should be available,
        // So, setup Not Recorded for Secondary Impression, if not already present
        impressionsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 2,
        })
      }
    } else if (userImpressionsCount === 0) {
      if (userImpressionsPNNVCount === 0) {
        // No impressions added, normal and PNNV. So add NV for bnoth Primary and Secondary Impressions
        impressionsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 1,
        })
        impressionsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 2,
        })
      } else {
        if (userImpressionsPNNVData[0].segmentId === 1) {
          // Add an array item with "Not Recorded" as not-value for Secondary Impression
          impressionsPNNV.push({
            ...NOT_RECORDED,
            segmentId: 2,
          })
        } else {
          // Add an array item with "Not Recorded" as not-value for Primary Impression
          impressionsPNNV.push({
            ...NOT_RECORDED,
            segmentId: 1,
          })
        }
        impressionsPNNV.push(...(userImpressionsPNNVData))
      }
    }

    data.diagnosis.impressionsPNNV = impressionsPNNV
    return data
  }

  /***
   * PNNVs for Symptoms requires more data transformation\addition to get it in shape that helps 
     to run schematron rules correctly.
     This function will make sure that:
     1. there is at least 1 entry for Primary Symptom (which is segmentId 1)
     2. there is at least 1 entry for Other Associtated Symptoms --> Other Associated Symptoms are marked
        with segmentId of 99 for Present Symptoms and with segmentId of -1 for "Symptoms Not Present".
     3. Adds pn key with value of "8801031" for all Other Associated Symptoms with segmentId of -1 in the "symptomsPNNVs" 
        section as this was missed in the UI code
     4. Copies all user selections for "Symptom Not Present" from symptomsPNNVs into symptoms. Cause these are 
        also ePatient.10 selections with a PN attribute. So should be in symptoms section as well.
  */
  public static setupPNNVForSymptoms(data: any): any {
    const NOT_RECORDED = {
      id: 7701003,
      name: 'Not Recorded',
      nv: '7701003',
      pn: '',
    }
    const userSymptomsPNNV = data?.diagnosis?.symptomsPNNVs
    let userSymptomsPNNVModified: any[] = []
    let symptomsPNNV: any[] = []
    if (!data.diagnosis.symptoms) {
      data.diagnosis.symptoms = []
    }
    const symptomsCount = data?.diagnosis?.symptoms?.length

    // Copy any user selections for "Symptom Not Present" from symptomsPNNv into symptoms. Cause these are 
    // also ePatient.10 selections with a PN attribute. So should be in symptoms section as well, not just 
    // symptomsPNNVs. Note that this cannot be done in the source-of-truth json, so we got to do it here
    if (userSymptomsPNNV?.length > 0) {
      if (symptomsCount === 0) {
        // symptoms object not available or empty, simply assigning PNNV records shuold create or replace it
        data.diagnosis.symptoms = userSymptomsPNNV
      }
      else {
        // symptoms object is available with array items, just add PNNV records into symptoms
        data.diagnosis.symptoms.push(...userSymptomsPNNV)
      }

      // Transform each item in userSymptomsPNNV to add 'nv' and set 'segmentId'
      userSymptomsPNNVModified = userSymptomsPNNV.map((symptom: any) => {
        return {
          ...symptom,     // Copy all existing properties from the original symptom
          pn: '8801031',  // Add the 'nv' property with your desired value
          nv: ''
        }
      })
    }

    if (symptomsCount === 0) {
      // No Symptoms added
      if (userSymptomsPNNVModified.length === 0) {
        // No PNNV data added by user
        symptomsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 1,
        })
        symptomsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 99,
        })
      }
      else {
        // PNNV data added by user (which can only be NV for "Not Present" with segment id of -1)
        // this "Not Present" entry pertains to eSituation.10 which is other symptoms
        // So, setup "Not Recorded" PNNV item for Primary Symptom and add the user PNNVs also
        symptomsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 1,
        })
        symptomsPNNV.push(...userSymptomsPNNVModified)
      }
    } else if (symptomsCount === 1) {
      // Count being 1, expect Primary Symptom to be filled, setup Not Recorded for Secondary Symptom
      if (userSymptomsPNNVModified.length === 0) {
        symptomsPNNV.push({
          ...NOT_RECORDED,
          segmentId: 99,
        })
      }
      else {
        symptomsPNNV.push(...userSymptomsPNNVModified)
      }
    } else {
      symptomsPNNV = userSymptomsPNNVModified
    }

    data.diagnosis.symptomsPNNVs = symptomsPNNV
    return data
  }
 
  public static CreateFactorsAffectingCareFactorsList(data: any) {
    if (data?.factorsAffectingCare?.prFactors) {

      data.factorsAffectingCare.prFactors.forEach(((factor: { type: number; id: number }) => {
        if (factor.type && (factor.type === 0 || factor.type === 1 || factor.type === 2)) {
          data.factorsAffectingCareState.factors.push({ id: factor.id })
        }
      }))

      return data
    }
  }
  public static combineVitals(data: any) {
    const combineVitalsType = [
      "airwayStateList",
      "cardiacStateList",
      "childbirthOBStateList",
      "drainStateList",
      "extricationStateList",
      "hospitalNotifyStateList",
      "imagingUltrasoundStateList",
      "immobilizationStateList",
      "initiateIvStateList",
      "intubationStateList",
      "medicalConsultStateList",
      "operationsStateList",
      "rescueStateList",
      "ventilatorStateList",
      "woundCareStateList",
      "bloodProductAdministrationStateList",
      "ventricularAssistDeviceStateList",
      "assessmentsStateList",
      "criticalCareStateList",
      "patientVitals"
    ]
    data.patient.combineVitalsTypeList = []


    combineVitalsType.forEach((key) => {
      if (Array.isArray(data.patient?.[key])) {
        data.patient.combineVitalsTypeList.push(...data.patient[key])
      }
    })
    if (Array.isArray(data.patient["procedureTypeStateListPNNVs"])) {
      data.patient["procedureTypeStateListPNNVs"].forEach((element) => {
        data.patient.combineVitalsTypeList.push(...element.procedurePNNVs)
      })
    }
    if (Array.isArray(data.patient["medicationAdministeredStateListPNNVs"])) {
      data.patient["medicationAdministeredStateListPNNVs"].forEach((element) => {
        data.patient.combineVitalsTypeList.push(...element.procedurePNNVs)
      })
    }
	   data?.patient?.combineVitalsTypeList.forEach((item : any) => {
      if (item && !item.hasOwnProperty('rhyCoded')) {
        item.rhyCoded = 1
      }
    })
    return data
  }
  public static populateProcedureTypeStateList(data: any) {
    const procedureTypes = [
      'airwayStateList',
      'cardiacStateList',
      'childbirthOBStateList',
      'drainStateList',
      'extricationStateList',
      'hospitalNotifyStateList',
      'imagingUltrasoundStateList',
      'immobilizationStateList',
      'initiateIvStateList',
      'intubationStateList',
      'medicalConsultStateList',
      'operationsStateList',
      'rescueStateList',
      'ventilatorStateList',
      'woundCareStateList',
      'bloodProductAdministrationStateList',
      'ventricularAssistDeviceStateList',
      'assessmentsStateList',
      'criticalCareStateList',
    ]
    data.patient.procedureTypeStateList = []
    procedureTypes.forEach((key) => {
      if (Array.isArray(data.patient[key])) {
        data.patient.procedureTypeStateList.push(...data.patient[key])
      }
    })
    if (Array.isArray(data.patient['procedureTypeStateListPNNVs'])) {
      data.patient['procedureTypeStateListPNNVs'].forEach((element) => {
        data.patient.procedureTypeStateList.push(...element.procedurePNNVs)
      })
    }

    if (Array.isArray(data.patient.airwayStateList)) {
      const nemsisCodesToCheck = [182692007, 7443007, 232664002]
      data.patient.airwayStateList.forEach((airway: any) => {
        if (nemsisCodesToCheck.includes(airway.nemsisCode)) {
          //Check if intubationStateList array exists or not. If not, create it.
          if (!Array.isArray(data.patient.intubationStateList)) {
            data.patient.intubationStateList = []
          }
          //push to intubation only if
          //airway nemsisCode is present in the list and the timeline key is not pushed already
          if (!data.patient.intubationStateList.some((intubation: any) => intubation.key === airway.key)) {
            data.patient.intubationStateList.push(airway)
          }
        }
      })
    }
    for (const [i, procedure] of data.patient.procedureTypeStateList.entries()) {
      const updatedsuccessfulAttempt = procedure.successfulAttempt ? 1 : 0
      // @ts-ignore
      data.patient.procedureTypeStateList[i].successfulAttempt = updatedsuccessfulAttempt
    }

    if (data.patient.procedureTypeStateList.length === 0) {
      // No records added to procedures, make it an empty list
      data.patient.procedureTypeStateList = [{}]
    }

    return data
  }

  public static extractFlattenedProcedures(
    pcrData: any,
    resultName: string,
    procedureKeys: string[] = [],
    exclude = false,
  ) {
    const result = []

    const allProcedureTypes = [
      'airwayStateList',
      'cardiacStateList',
      'childbirthOBStateList',
      'drainStateList',
      'extricationStateList',
      'hospitalNotifyStateList',
      'imagingUltrasoundStateList',
      'immobilizationStateList',
      'initiateIvStateList',
      'intubationStateList',
      'medicalConsultStateList',
      'operationsStateList',
      'rescueStateList',
      'ventilatorStateList',
      'woundCareStateList',
      'bloodProductAdministrationStateList',
      'ventricularAssistDeviceStateList',
      'assessmentsStateList',
      'criticalCareStateList',
      'labsStateList',
      'titrateStateList',
      'medicationAdministeredStateList',
      'medicationAdministeredStateListPNNVs',
      'procedureTypeStateListPNNVs'
    ]

    let applicableProcedureKeys: string[]
    if (!procedureKeys || procedureKeys.length === 0) {
      applicableProcedureKeys = allProcedureTypes
    } else if (exclude) {
      applicableProcedureKeys = allProcedureTypes.filter(type => !procedureKeys.includes(type))
    } else {
      applicableProcedureKeys = procedureKeys
    }

    for (const procedureKey of applicableProcedureKeys) {
      const procedureList = pcrData.patient[procedureKey]
      if (!Array.isArray(procedureList)) continue

      for (const item of procedureList) {

        let entries

        // Handle nested lists based on known procedure structures
        if (procedureKey === 'medicationAdministeredStateList' || procedureKey === 'medicationAdministeredStateListPNNVs') {
          const dataArray: any = []
          entries = item.addMedicationAdministeredData || []

          const { date, time, pta, rolePerforming, authorization, assessedBy, addMedicationAdministeredData, comments } = item
          // Handle case where medication administered action doesn't have any medications
          if (addMedicationAdministeredData.length === 0) {
            const flattenedMedicineData = {
              date,
              time,
              pta,
              rolePerforming,
              authorization,
              assessedBy,
              comments
            }
            dataArray.push(flattenedMedicineData)
          } else {
            addMedicationAdministeredData.forEach((medicationData: any) => {
              const flattenedMedicineData = {
                date,
                time,
                pta,
                rolePerforming,
                authorization,
                assessedBy,
                comments,
                ...medicationData,
              }
              dataArray.push(flattenedMedicineData)
            })
          }
          entries = dataArray || []
        } else if (procedureKey === 'procedureTypeStateListPNNVs') {
          entries = item.procedurePNNVs || []
        } else {
          entries = [item]
        }

        for (const entry of entries) {
          result.push(entry)
        }
      }
    }

    pcrData.patient[resultName] = result
    return pcrData
  }

  /**
   * Extracts and filters procedure data based on procedure keys and additional criteria
   * @param pcrData PCR data
   * @param resultName New key beneath `$.patient` where output should be stored
   * @param procedureKeys Array of procedures to either include or exclude
   * @param exclude If set to true, matches all procedures EXCEPT those listed in `procedureKeys`
   * @param condition Additional filter criteria to use for pruning procedures
   *  @param excludeCondition If set to true, matches all procedures EXCEPT those matching `condition`
   * 
   * **e.g.** Using this method to extract `cardiacStateList` values using the condition argument
   * `{ path: 'action', values: ['Internal Pacing', 'External Pacing'] }` would search `$.patient.cardiacStateList`
   * for records matching either `{ action: 'Internal Pacing' }` or `{ action: 'External Pacing' }`
   * @returns PCR data with filtered procedure data added as new key
   */
  public static extractFlattenedProceduresConditional(
    pcrData: any,
    resultName: string,
    procedureKeys: string[] = [],
    exclude = false,
    condition: {path: string, values: string[]},
    excludeCondition = false
  ) {
    // 1. Run standard extractFlattenedProcedures method to stage procedure data at the specified PCR path.
    pcrData = this.extractFlattenedProcedures(pcrData, resultName, procedureKeys, exclude)

    // 2. Filter the output of step 1 to only include the subset of the initial result matching the condition argument.
    const result = pcrData.patient[resultName].filter((p: any) => condition.values.includes(this.getValueByPath(p, condition.path)) !== excludeCondition)

    // 3. Write the filtered subset out to the specified PCR path.
    pcrData.patient[resultName] = result
    return pcrData
  }

  private static getDatafromPath(pcrData: any, pathToData: string): any {
    const pathSegments = pathToData.split('.')
    let current = pcrData

    for (let i = 0; i < pathSegments.length; i++) {
      if (current[pathSegments[i]] === undefined) {
        return null // path doesn't exist
      }
      current = current[pathSegments[i]]
    }

    return current
  }

  public static copyKey(pcrData: any, pathToData: string, fromKey: string, toKey: string, removeOriginal: boolean, isArray: boolean) {
    const current = this.getDatafromPath(pcrData, pathToData)
    if (!current) return pcrData

    if (isArray && Array.isArray(current)) {
      current.forEach(item => {
        if (item && item.hasOwnProperty(fromKey)) {
          item[toKey] = item[fromKey]
          if (removeOriginal) delete item[fromKey]
        }
      })
    } else {
      if (current && current.hasOwnProperty(fromKey)) {
        current[toKey] = current[fromKey]
        if (removeOriginal) delete current[fromKey]
      }
    }

    return pcrData
  }
  public static countVitals(data: any) {
    const vitalTypes = ["patientVitals"]
    const counts: Record<string, number> = {}
    vitalTypes.forEach((listName) => {
      if (Array.isArray(data?.patient?.[listName])) {
        data.patient[listName].forEach((vital: Record<string, any>) => {
          Object.entries(vital).forEach(([field, value]) => {
            if (value !== null && value !== undefined && value !== "" && value !== 0) {
              counts[field] = (counts[field] || 0) + 1
            }
          })
        })
      }
    })
    data.patient.countedVitals = counts
    return data
  }

  public static vitalsCount(data: any): number {
    const vitalsCount = data?.patient?.patientVitals ? data.patient.patientVitals.length : 0
    data.patient.vitalsCount  = vitalsCount
    return data
  }
  public static countForms(data: any) {
    
    if (data?.prFormsCustom == null)
      return data
    
    const countForms = data?.prFormsCustom ? data.prFormsCustom.length : 0
    data.prFormsCustom.countForms = countForms
    return data
  }
  public static fetchCadLocalId(data: any) {
    let localId = ''
    const importedData = data?.cadImport?.importedCadData

    if (Array.isArray(importedData)) {
      const match = importedData.find(
        (item: any) =>
          item?.displayLabel === 'Local ID' &&
          item.performImport &&
          item.value
      )

      if (match) localId = match.value
    }

    data.patient ??= {}
    data.patient.tripInformation ??= {}

    data.patient.tripInformation.cadLocalId = data.cadImport ? localId : null

    return data
  }

  public static fetchWasPtImmobilized(data: any) {
    if (!data.prNabc) {
      data.prNabc = {}
    }
    data.prNabc.wasPtImmob = 0

    if (data?.prAssess && data.prAssess.length > 0) {
      const sources = [
        data?.prAssess[0]?.immCid, data?.prAssess[0]?.immCollar,
        data?.prAssess[0]?.immKed, data?.prAssess[0]?.immLbb,
        data?.prAssess[0]?.immMast, data?.prNabc?.immobOutcome,
        data?.prNabc?.immobBy
      ]

      const hasValidValue = sources.some((item) => {
        if (typeof item === 'object' && item !== null) {
          return Object.entries(item).some(
            ([_, value]) => !!value
          )
        }
        else {
          return !!item
        }
      })
      if (hasValidValue) {
        data.prNabc.wasPtImmob = 1
      }
    }

    return data
  }

  public static fetchExposureCrewData(data: any) {
    if (!data.exposure) {
      data.exposure = {}
    }
    if (Array.isArray(data.exposure.crewList) && data.exposure.crewList.length > 0) {
      const crewList = data.exposure.crewList
      for (let i = 0; i < crewList.length - 2; i++) {
        data.exposure.crewList[`crew${i + 1}`] = crewList[i]
      }
      if (crewList.length >= 2) {
        data.exposure.crewList.otherEMS = crewList[crewList.length - 2]
        data.exposure.crewList.nonEMSIndividdual = crewList[crewList.length - 1]
      }
    }
    return data
  }

  public static fetchProcedureCrewData(data: any) {
    if (!data.patient.allCombinedProcedures) {
      data.patient.allCombinedProcedures = {}
    }
    data.patient.procedureCrew = null

    let hasValidCrew = false
    if (Array.isArray(data.patient.allCombinedProcedures)) {
      for (const el of data.patient.allCombinedProcedures) {
        if (el.assessedBy && Object.keys(el.assessedBy).length > 0) {
          hasValidCrew = true
          break
        }
      }
    }

    if (hasValidCrew) data.patient.procedureCrew = true
    return data
  }

  public static createVitalsOffsets(data: any) {

    const defaultValue = 9999
    const arriveRecDate = data.times?.arriveReceivingDate ?? ''
    const arriveRecTime = data.times?.arriveReceivingTime ?? ''
    data.patient.patientVitalsLastBPOffset = defaultValue
    data.patient.patientVitalsLastHROffset = defaultValue
    data.patient.patientVitalsLastRespOffset = defaultValue

    if (!arriveRecDate || !arriveRecTime) {
      return data
    }

    const arriveReceiving = DateTime.fromFormat(`${arriveRecDate} ${arriveRecTime}`, 'MM/dd/yy HH:mm:ss')

    const vitals = data.patient.patientVitals

    if (!vitals || vitals.count === 0) {
      return data
    }

    const findOffset = (validator: (v: any) => boolean): number => {
      for (let i = vitals.length - 1; i >= 0; i--) {
        const vital = vitals[i]
        if (!vital.date || !vital.time) continue

        const dtVital = DateTime.fromFormat(`${vital.date} ${vital.time}`, 'MM/dd/yy HH:mm:ss')
        if (dtVital > arriveReceiving) continue

        if (validator(vital)) {
          return arriveReceiving.diff(dtVital, 'minutes').minutes
        }
      }

      return defaultValue
    }

    data.patient.patientVitalsLastBPOffset = findOffset(
      (v) =>
        v.systolicBP != null &&
        v.systolicBP !== '' &&
        v.diastolicBP != null &&
        v.diastolicBP !== ''
    )
    data.patient.patientVitalsLastHROffset = findOffset(
      (v) => v.heartRate != null && v.heartRate !== ''
    )
    data.patient.patientVitalsLastRespOffset = findOffset(
      (v) => v.respirationRate != null && v.respirationRate !== ''
    )
    return data
  }
  public static combineFieldsAtPath(pcrData: any, pathToData: string, sourceKey1: string, sourceKey2: string, destinationKey: string) {
    const target = this.getDatafromPath(pcrData, pathToData)
    if (!target) return pcrData

    if (Array.isArray(target)) {
      target.forEach(item => {
        item[destinationKey] = item[sourceKey1] || item[sourceKey2] || null
      })
    } else if (typeof target === 'object' && target !== null) {
      target[destinationKey] = target[sourceKey1] || target[sourceKey2] || null
    }

    return pcrData
  }

  static combineBooleanFieldsAtPath(
    pcrData: any,
    pathToData: string,
    destinationKey: string,
    options: {
      includeFalse?: boolean,
      includeNonBoolean?: boolean,
      fieldFilter?: (key: string, value: any) => boolean,
      valueFilter?: (key: string, value: any) => boolean,
      separator?: string,
      formatField?: (key: string) => string,
      formatValue?: (key: string, value: any) => string,
      onlyTrueBooleans?: boolean
    } = {}
  ) {
    if (!pcrData || !pathToData) return pcrData

    const {
      includeFalse = false,
      includeNonBoolean = false,
      fieldFilter = null,
      valueFilter = null,
      separator = ', ',
      formatField = (key: any) => key,
      formatValue = (key: string, value: any) => value,
      onlyTrueBooleans = true
    } = options

    const target = this.getDatafromPath(pcrData, pathToData)
    if (!target) return pcrData

    const processObject = (obj: Record<string, any>) => {
      if (!obj || typeof obj !== 'object' || obj === null) return ''

      return Object.entries(obj)
        .filter(([key, value]) => {
          if (fieldFilter && !fieldFilter(key, value)) return false
          if (valueFilter && !valueFilter(key, value)) return false

          if (typeof value === 'boolean') {
            return onlyTrueBooleans ? value === true : includeFalse
          }
          return includeNonBoolean
        })
        .map(([key, value]) => {
          return typeof value === 'boolean' ? formatField(key) : formatValue(key, value)
        })
        .filter(Boolean)
        .join(separator)
    }

    if (Array.isArray(target)) {
      target.forEach(item => {
        if (item && typeof item === 'object' && item !== null) {
          item[destinationKey] = processObject(item)
        }
      })
    } else if (target && typeof target === 'object' && target !== null) {
      target[destinationKey] = processObject(target)
    }

    return pcrData
  }

  // Copy Common Address name to txToCode.name value for stateId comparison
  public static copyHospitalNameForIdComp(data: any) {
    const commonHospitalName = data?.disposition?.destination?.commonAddress?.name
    if (!commonHospitalName) return data

    data.disposition.destination.txToCode.name = commonHospitalName
    if (data.disposition.destination.txToCode.namePNNV) {
      data.disposition.destination.txToCode.namePNNV = undefined
    }
    return data
  }

  // If a state hospital has a NEMSIS export name standard, use it's value for comparison
  static copyNemsisHospitalNameForComparison(data: any) {
    const stateIds = data?.disposition?.destination?.txToCode?.stateIds
    const stateIdToSearch = data?.disposition?.destination?.txToCode?.state

    const match = stateIds?.find((stateIdItem: any) => stateIdToSearch && stateIdItem?.state === stateIdToSearch)

    if (match?.nemsisName && data?.disposition?.destination?.txToCode) {
      data.disposition.destination.txToCode.name = match.nemsisName
    }

    return data
  }

  public static consolidateComplaintData(data: any) {
    const modifiedComplaints: any = []

    // If data.situation doesn't exist create it for complaintGroup assignment
    if (!data?.situation) {
      data.situation = {}
    }

    // Chief Complaint
    if (data?.situation?.complaint || data?.situation?.ccDuration || data?.situation?.ccDurationUnit) {
      modifiedComplaints.push({
        complaintType: 2803001,
        complaint: data?.situation?.complaint,
        duration: data?.situation?.ccDuration,
        durationUnit: data?.situation?.ccDurationUnit,
      })
    }

    // Secondary Complaint
    if (data?.situation?.secondaryComplaint || data?.situation?.scDuration || data?.situation?.scDurationUnit) {
      modifiedComplaints?.push({
        complaintType: 2803005,
        complaint: data?.situation?.secondaryComplaint,
        duration: data?.situation?.scDuration,
        durationUnit: data?.situation?.scDurationUnit,
      })
    }

    // Other Complaints
    if (data?.situation?.otherComplaints && data?.situation?.otherComplaints?.length >= 1) {
      data?.situation?.otherComplaints?.forEach((oc: any) => {
        modifiedComplaints?.push({
          complaintType: 2803003,
          complaint: oc?.otherComplaint,
          duration: oc?.ocDuration,
          durationUnit: oc?.ocDurationUnit,
        })
      })
    }

    if (data?.situation) {
      data.situation.complaintGroup = modifiedComplaints
    }

    //This is added to run the loop for complaintGroup loop at least once if it exists in any rule
    if (data.situation.complaintGroup.length === 0) {
      data.situation.complaintGroup.push({
        dummyId: '1',
      })
    }
    return data
  }

  public static verifyPatientPresence(data: any) {
    if(!data?.patient?.patientInformation) return data

    const isValidValue = (val: any): boolean => {
      if (val === null || val === '') return false
      if (Array.isArray(val)) return val.length > 0
      if (typeof val === 'object') {
        return Object.values(val).some((a) => isValidValue(a))
      }
      return true
    }

    // Keys to skip from validation as they have some default values
    const skipKeys = ['weightUnits', 'heightUnits']
    //Exclude values for PNNV fields
    const excludePNNVValues = ['Not Recorded']

    const objectExists = (obj: any): boolean => {
      if (obj === null || obj === undefined) return false
      if (typeof obj !== 'object') return isValidValue(obj)

      return Object.entries(obj).some(([key, value]) => {
        if (skipKeys.includes(key) || typeof value === 'boolean') return false

        if (key.endsWith('PNNV') && value && typeof value === 'object' && 'name' in value) {
          const name = (value as { name: string }).name
          return !excludePNNVValues.includes(name)
        }

        if (isValidValue(value)) return true

        return false
      })
    }

    const hasChild = (obj: any): boolean => {
      return Array.isArray(obj) ? obj.length > 0 : typeof obj === 'object' && obj !== null
    }

    const hasPtDemographics = objectExists(data.patient?.patientDemographics)
    const hasPtMedicalHistory = objectExists(data.patient?.patientMedicalHistory)
    const hasPtAllergies = objectExists(data.patient?.patientAllergies)
    const hasPtMedications = objectExists(data.patient?.patientMedications)
    const hasPtImmunizations = objectExists(data.patient?.patientImmunizations)

    // Billing checks
    const hasInsuranceInformationList = hasChild(data.billing?.insuranceInformation?.insuranceInformationList)
    const hasRelationshipsAndGuarantorsList = hasChild(data.billing?.relationshipsAndGuarantors?.relationshipsAndGuarantorsList)

    const hasPtid = typeof data.ptid === 'number' || !isNaN(parseInt(data.ptid))
    const hasPatient = hasPtDemographics || hasPtMedicalHistory || hasPtAllergies || hasPtMedications || hasPtImmunizations
    const hasBilling = hasInsuranceInformationList || hasRelationshipsAndGuarantorsList
    data.patient.patientInformation.hasPatient = hasPatient || hasBilling || hasPtid

    return data
  }


  public static flattenData(dataArray: any, medicationData: any) {
    medicationData.forEach((item: any) => {
      const { date, time, pta, rolePerforming, authorization, assessedBy, administeredByAnotherUnit,
        administeredByAnotherUnitPNNV, addMedicationAdministeredData, datePNNV } = item
      // Handle case where medication administered action doesn't have any medications
      if (addMedicationAdministeredData.length === 0) {
        const flattenedMedicineData = {
          date,
          time,
          pta,
          rolePerforming,
          authorization,
          assessedBy,
          administeredByAnotherUnit,
          administeredByAnotherUnitPNNV,
          datePNNV,
        }
        dataArray.push(flattenedMedicineData)
      } else {
        addMedicationAdministeredData.forEach((medicationData: any) => {
          if (medicationData.dose != null && medicationData.doseUnit != null) {            
            medicationData.dose = this.convertMedicationDose(medicationData.dose, medicationData.doseUnit.nemsisMultiplyFactor)
          }
          
          const flattenedMedicineData = {
            date,
            time,
            pta,
            rolePerforming,
            authorization,
            assessedBy,
            administeredByAnotherUnit,
            administeredByAnotherUnitPNNV,
            datePNNV,
            ...medicationData,
          }
          dataArray.push(flattenedMedicineData)
        })
      }
    })
  }

  private static convertMedicationDose (dose: string, nemsisMultiplyFactor: number){
    const convertedDose = Number(dose) * nemsisMultiplyFactor
    return convertedDose?.toString()
  }

  public static flattenMedicationData(data: any) {
    data.patient.flattenedMedicationArray = []
    if (Array.isArray(data.patient.medicationAdministeredStateList)) {
      this.flattenData(data.patient.flattenedMedicationArray, data.patient.medicationAdministeredStateList)
    }
    if (Array.isArray(data.patient.medicationAdministeredStateListPNNVs)) {
      this.flattenData(data.patient.flattenedMedicationArray, data.patient.medicationAdministeredStateListPNNVs)
    }
    return data
  }

  public static copyExamPNValues(data: any) {
    const bodySurveys = data?.additionalAssessment?.bodySurveys

    if (Array.isArray(bodySurveys)) {
      bodySurveys.forEach((survey) => {
        const pnnvs = survey.examValuesPNNVs
        const examValues = survey.examValues

        if (Array.isArray(pnnvs) && Array.isArray(examValues)) {
          examValues.push(...pnnvs)
        }
      })
    }

    return data
  }

  public static extractBasedOnPTA(data: any, arrayPath: string): any {

    const pathSegments = arrayPath.split('.')
    const arrayKey = pathSegments.pop()

    if (!arrayKey) {
      return data
    }

    let parentObject = data

    for (const segment of pathSegments) {
      if (parentObject && parentObject.hasOwnProperty(segment)) {
        parentObject = parentObject[segment]
      } else {
        return data
      }
    }

    const TargetArray = parentObject[arrayKey]

    if (!Array.isArray(TargetArray)) {
      return data
    }

    const withPTAKey = `${arrayKey}WithPTA`
    const withoutPTAKey = `${arrayKey}WithoutPTA`

    parentObject[withPTAKey] = []
    parentObject[withoutPTAKey] = []

    TargetArray.forEach((item: any) => {
      if (item.hasOwnProperty('pta') && item.pta === true) {
        parentObject[withPTAKey].push({ ...item })
      }
      else if (item.hasOwnProperty('pta') && item.pta === false) {
        parentObject[withoutPTAKey].push({ ...item })
      }
    })

    return data
  }

  public static transformTotalPatientsAtScene(pcrData: any) {
    if (!pcrData.sceneDescription) return pcrData

    const numPtsScene = Number(pcrData.sceneDescription?.numPtsScene)
    if (isNaN(numPtsScene)){
      // @ts-ignore
      pcrData.sceneDescription.numPtsScene = 2707003
      return pcrData
    }


    if (numPtsScene === 0) {
      // @ts-ignore
      pcrData.sceneDescription.numPtsScene = 2707003
    } else if (numPtsScene === 1) {
      // @ts-ignore
      pcrData.sceneDescription.numPtsScene = 2707005
    } else {
      // @ts-ignore
      pcrData.sceneDescription.numPtsScene = 2707001
    }

    return pcrData
  }

  public static transformVitalsPTA(pcrData: any): any {
    const patientVitals = pcrData?.patient?.patientVitals
    if (!patientVitals) return pcrData

    for (const [i, vital] of patientVitals.entries()) {
      if (typeof vital.pta === 'boolean') {
        const updatedPTA = vital.pta === true ? 1 : 0
        // @ts-ignore
        pcrData.patient.patientVitals[i].pta = updatedPTA
      }

    }

    return pcrData
  }

  public static transformLabsPTA(pcrData: any): IPcr {
    const labsData = pcrData?.patient?.labsStateList
    if (!labsData) return pcrData

    for (const [i, lab] of labsData.entries()) {
      if (typeof lab.pta === 'boolean') {
        const updatedPTA = lab.pta === true ? 1 : 0
        // @ts-ignore
        pcrData.patient.labsStateList[i].pta = updatedPTA
      }

    }

    return pcrData
  }

  public static formatDateTimeErrorMessage(errorMessage: string) {
    const strToReplace =
      '<sch:value-of select="format-dateTime(current-dateTime(),\'[MNn] [D1], [Y0001], [H01]:[m01] [ZN]\')" xmlns:sch="http://purl.oclc.org/dsdl/schematron" />'
    const formattedDateTime = DateTime.now().toFormat('MMMM dd, yyyy, HH:mm ZZ')
    const dateTimeError = errorMessage?.replace(strToReplace, formattedDateTime)
    return dateTimeError
  }

  public static transformMedicationsPTA(pcrData: any): any {
    const medications = pcrData?.patient?.medicationAdministeredStateList
    if (!medications) return pcrData

    for (const [i, medication] of medications.entries()) {
      if (medication && 'pta' in medication) {
        const updatedPTA = medication.pta === true ? 1 : 0
        // @ts-ignore
        pcrData.patient.medicationAdministeredStateList[i].pta = updatedPTA
      }
    }

    return pcrData
  }

  public static transformProceduresPTA(pcrData: any): any {
    // @ts-ignore
    const procedures = pcrData?.patient?.procedureTypeStateList
    if (!procedures) return pcrData

    for (const [i, procedure] of procedures.entries()) {
      if (procedure && 'pta' in procedure) {
        const updatedPTA = procedure.pta === true ? 1 : 0
        // @ts-ignore
        pcrData.patient.procedureTypeStateList[i].pta = updatedPTA
      }
    }

    return pcrData
  }

  public static transformProtocolAgeCategory(pcrData: any): IPcr {
    const patientVitals = pcrData?.patient?.patientVitals
    if (!patientVitals) return pcrData

    for (const [i, vital] of patientVitals.entries()) {
      const protocol = vital.protocol
      if (protocol?.protocolAgeCategory === 0) {
        pcrData.patient.patientVitals[i].protocol.protocolAgeCategory = null
      }
    }

    return pcrData
  }

  public static createNemsisIntubation(data: any) {
    if (data.patient.intubationStateList && data.patient.intubationStateList.length > 0) {
      data.patient.intubationStateListNemsis = {
        indications: [],
        confirmationGroup: [],
        airwayComplications: [],
        airwayComplicationsPNNV: {},
        reasonsForFailure: [],
        decisiontoManageTime: '',
        decisiontoManageDate: '',
        abandonedTime: '',
        abandonedDate: '',
      }
      data.patient.intubationStateList.forEach((item: any) => {
        const confirmationGroupElement = {
          date: item.date || '',
          time: item.time || '',
          method: item.method || undefined,
          verificationVia: item.verificationVia || [],
          distance: item.distance || undefined,
          verifiedBy: item.verifiedBy || undefined,
          assessedBy: item.assessedBy || undefined,
        }
        data.patient.intubationStateListNemsis.confirmationGroup.push(confirmationGroupElement)

        if (item.indications && item.indications.length > 0) {
          item.indications.forEach((indication: any) => {
            data.patient.intubationStateListNemsis.indications.push(indication)
          })
        }
        if (item.airwayComplications && item.airwayComplications.length > 0) {
          item.airwayComplications.forEach((airwayComplication: any) => {
            data.patient.intubationStateListNemsis.airwayComplications.push(airwayComplication)
          })
        } else if (item.airwayComplicationsPNNV) {
          data.patient.intubationStateListNemsis.airwayComplicationsPNNV = item.airwayComplicationsPNNV
        }

        if (item.reasonsForFailure && item.reasonsForFailure.length > 0) {
          item.reasonsForFailure.forEach((failureReason: any) => {
            data.patient.intubationStateListNemsis.reasonsForFailure.push(failureReason)
          })
        }
        if (item.decisiontoManageDate && !data.patient.intubationStateListNemsis.decisiontoManageDate) {
          data.patient.intubationStateListNemsis.decisiontoManageDate = item.decisiontoManageDate
        }
        if (item.decisiontoManageTime && !data.patient.intubationStateListNemsis.decisiontoManageTime) {
          data.patient.intubationStateListNemsis.decisiontoManageTime = item.decisiontoManageTime
        }
        if (item.abandonedDate && !data.patient.intubationStateListNemsis.abandonedDate) {
          data.patient.intubationStateListNemsis.abandonedDate = item.abandonedDate
        }
        if (item.abandonedTime && !data.patient.intubationStateListNemsis.abandonedTime) {
          data.patient.intubationStateListNemsis.abandonedTime = item.abandonedTime
        }
      })
      if (
        data.patient.intubationStateListNemsis.airwayComplications &&
        data.patient.intubationStateListNemsis.airwayComplications.length > 0
      ) {
        data.patient.intubationStateListNemsis.airwayComplicationsPNNV = null
      }
    }
    return data
  }

  public static fillPickupAndDestinationStateId(data: any, stateInitial: string) {
    let stateIdsArray: any = []
    let stateIdObj: any = {}

    if (data?.disposition?.destination) {
      stateIdsArray = data.disposition.destination.stateIds
      stateIdObj = stateIdsArray && stateIdsArray.length > 0 ? stateIdsArray.find((item: any) =>
        item.state === stateInitial ||
        (stateInitial === 'Schematron' && item.state === data.disposition.destination.state?.id)
      ) : ''

      if (stateIdObj && stateIdObj.stateId) {
        data.disposition.destination.txToCode.id = stateIdObj.stateId
      }
      else {
        data.disposition.destination.txToCode.id = ''
      }
    }

    if (data?.patient?.pickupAddress?.otherType) {
      stateIdsArray = data.patient.pickupAddress.stateIds
      stateIdObj = stateIdsArray && stateIdsArray.length > 0 ? stateIdsArray.find((item: any) =>
        item.state === stateInitial ||
        (stateInitial === 'Schematron' && item.state === data.patient.pickupAddress.state?.id)
      ) : ''

      if (stateIdObj && stateIdObj.stateId) {
        data.patient.pickupAddress.otherType.id = stateIdObj.stateId
      } else {
        data.patient.pickupAddress.otherType.id = ''
      }
    }

    return data
  }

  public static fetchUnitStateLicenseID(data: any, stateInitial: string): any {
    const unitValue = data?.patient?.tripInformation?.unit
    const stateIdsForUnits = unitValue?.stateIds
    const regTailValue = data?.patient?.tripInformation?.registrationTailNumber
    const stateIdsForRegTail = regTailValue?.stateIds
    let matchUnit:any = {}
    let matchRegTailNumber:any = {}

    if (Array.isArray(stateIdsForUnits)) {
      matchUnit = stateIdsForUnits.find((item: any) => item.stateId === stateInitial)
    }
    if (Array.isArray(stateIdsForRegTail)) {
      matchRegTailNumber = stateIdsForRegTail.find((item: any) => item.stateId === stateInitial)
    }
    
    if (matchUnit?.nemsis14) {
      if (!data.patient.tripInformation.unit) {
        data.patient.tripInformation.unit = {}
      }
      data.patient.tripInformation.unit.id = matchUnit.nemsis14
    }
    
    else if(matchRegTailNumber?.nemsis14) {
      if (!data.patient.tripInformation.unit) {
        data.patient.tripInformation.unit = {}
      }
      data.patient.tripInformation.unit.id = matchRegTailNumber.nemsis14
    }

    else if(unitValue?.name){
      if (!data.patient.tripInformation.unit) {
        data.patient.tripInformation.unit = {}
      }
      data.patient.tripInformation.unit.id = unitValue?.name
    }

    else if(regTailValue?.name) {
      if (!data.patient.tripInformation.unit) {
        data.patient.tripInformation.unit = {}
      }
      data.patient.tripInformation.unit.id = regTailValue?.name
    }

    return data
  }

  /**
  * Populates the `registrationTailNumber.name` property on the trip information
  * object if it is not already set.
  *
  * @param data The pcr data object to update.
  */
  public static updateUnitRegistrationTailNumber(data: any, stateInitial: string) {
    const unitValue = data?.patient?.tripInformation?.unit
    const stateIdsForUnits = unitValue?.stateIds
    const regTailValue = data?.patient?.tripInformation?.registrationTailNumber
    const stateIdsForRegTail = regTailValue?.stateIds
    let matchUnit:any = {}
    let matchRegTailNumber:any = {}

    if (Array.isArray(stateIdsForUnits)) {
      matchUnit = stateIdsForUnits.find((item: any) => item.stateId === stateInitial)
    }

    if (Array.isArray(stateIdsForRegTail)) {
      matchRegTailNumber = stateIdsForRegTail.find((item: any) => item.stateId === stateInitial)
    }
    
    if(matchRegTailNumber?.nemsis13) {
      if (!data.patient.tripInformation.registrationTailNumber) {
        data.patient.tripInformation.registrationTailNumber = {}
      }
      data.patient.tripInformation.registrationTailNumber.id = matchRegTailNumber.nemsis13
    }

    else if (matchUnit?.nemsis13) {
      if (!data.patient.tripInformation.registrationTailNumber) {
        data.patient.tripInformation.registrationTailNumber = {}
      }
      data.patient.tripInformation.registrationTailNumber.id = matchUnit.nemsis13
    }
    
    else if(regTailValue?.name) {
      if (!data.patient.tripInformation.registrationTailNumber) {
        data.patient.tripInformation.registrationTailNumber = {}
      }
      data.patient.tripInformation.registrationTailNumber.id = regTailValue?.name
    }

    else if(unitValue?.name){
      if (!data.patient.tripInformation.registrationTailNumber) {
        data.patient.tripInformation.registrationTailNumber = {}
      }
      data.patient.tripInformation.registrationTailNumber.id = unitValue?.name
    }
    
    return data
  }

  /**
  * Extracts a record from IndexedDB by id
  * @param dbName - The name of the IndexedDB database
  * @param storeName - The name of the object store
  * @param id - The id/key of the record to retrieve
  */
  public static extractRecord(dbName: string, storeName: string, id: IDBValidKey): Promise<any> {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(dbName)
      request.onerror = function () {
        console.error('Failed to open database:', request.error)
        reject(request.error)
      }

      request.onsuccess = function () {
        const db = request.result
        const transaction = db.transaction(storeName, 'readonly')
        const objectStore = transaction.objectStore(storeName)
        const getRequest = objectStore.get(id)

        getRequest.onerror = function () {
          console.error('Failed to retrieve record:', getRequest.error)
          db.close()
          reject(getRequest.error)
        }

        getRequest.onsuccess = function () {
          if (getRequest.result) {
            db.close()
            resolve(getRequest.result)
          } else {
            console.log('No record found with id:', id)
            db.close()
            resolve(null)
          }
        }
      }
    })
  }

  public static licensureDataCache: Record<string, any> = {}

  /**
   * Load licensure data from IndexedDB into cache.
   * @param data - The pcr data object to read from.
   */
  public static loadDataFromIndexedDB(data: any): void {
    const serviceId: string = data.serviceId

    // Cache already been loaded for this service
    if (this.licensureDataCache && this.licensureDataCache[serviceId]) {
      return
    }

    // Fire and forget - load data in background
    ;(async () => {
      try {
        const dbName = `zoll_now_${serviceId}`
        const storeName = 'clientData'
        const id = 'tb_crew_licensures_data-custom'

        this.licensureDataCache[serviceId] = await this.extractRecord(dbName, storeName, id)
        console.log('Licensure data loaded into cache')
      } catch (error) {
        console.error(`Failed to load licensure data for service: ${serviceId}`, error)
      }
    })()
  }

  public static findNemsisCode(licensureData: any, userId: any, state: string): string | null {
    if (!licensureData || !licensureData.entity) {
      console.error('Invalid licensure data structure')
      return null
    }

    const entity = licensureData.entity.find((e: any) => e.userId === userId)

    // User not found
    if (!entity) {
      console.error(`User not found with id: ${userId}`)
      return null
    }

    const licensure = entity.licensures.find((l: any) => l.state === state)

    // State not found for this user
    if (!licensure) {
      console.error(`State not found for user with id: ${userId} in state: ${state}`)
      return null
    }

    return licensure.nemsisCode
  }

  public static fetchCrewLicensureId(data: any, stateInitial: string): any {
    const notRecorded = {
      id: 7701003,
      name: 'Not Recorded',
      nv: '7701003',
      pn: '',
    }

    const serviceId = data.serviceId

    if (Array.isArray(data?.crew)) {
      data?.crew.forEach((item: any) => {
        const userId = item.user?.id

        // Use cached licensure data
        const record = this.licensureDataCache && this.licensureDataCache[serviceId]
        item.licensureTypeCode = this.findNemsisCode(record, userId, stateInitial)

        console.log(`NEMSIS license type code for user ${userId} in state ${stateInitial}:`, item.licensureTypeCode)

        item.licensureId = item?.licensures?.[stateInitial]?.id ?? ''

        // Assign licensureIdPNNV as Not Recorded when licensureId or licensureType is empty
        if (item.licensureId === '') {
          item.licensureIdPNNV = notRecorded
        }

        if (this.falsyExceptZero(item.licensureTypeCode)) {
          item.licensureTypePNNV = notRecorded
        }
      })
    }

    const assessedByDataPaths = [
      data?.patient?.intubationStateListNemsis?.confirmationGroup,
      data?.patient?.flattenedMedicationArray,
      data?.patient?.procedureTypeStateList,
      data?.signerDetails,
      data?.exposure?.exposureList
    ]

    assessedByDataPaths.forEach((item: any) => {
      item?.forEach((item1: any) => {
        if (item1?.assessedBy) {
          const crewUser = data.crew.find((crewItem: any) => crewItem.user.id === item1.assessedBy.id)
          if (crewUser) {
            item1.assessedBy.licensureId = crewUser.licensureId ?? ''
          }
        }
        else if (item1?.user) {
          const crewUser = data.crew.find((crewItem: any) => crewItem.user.id === item1.user.id)
          if (crewUser) {
            item1.user.licensureId = crewUser.licensureId ?? ''
          }
        }
        else if (item1?.crewId) {
          const crewUser = data.crew.find((crewItem: any) => crewItem.user.id === item1.crewId)
          if (crewUser) {
            item1.licensureId = crewUser.licensureId ?? ''
          }
        }
      })
    })

    assessedByDataPaths.forEach((item: any) => {
      item?.forEach((item1: any) => {
        const keys = ['assessedBy', 'user', 'crewId']

        keys.forEach((key) => {
          if (item1[key] && (!item1[key].hasOwnProperty('licensureId') || item1[key].licensureId === '')) {
            item1.licensureIdPNNV = notRecorded
          }
        })
      })
    })
    if (data?.signerDetails.length === 0) {
      data.signerDetails = [
        {
          licensureIdPNNV: notRecorded
        }
      ]
    }

    return data
  }

  public static formatDataForSSN(data: any) {
    if (data?.patient?.patientDemographics?.sSN) {
      data.patient.patientDemographics.sSN = data?.patient?.patientDemographics?.sSN.replaceAll('-', '')
    }
    return data
  }

  public static copyVitalsFieldsIntoCustomData(data: any, regions: string[]) {
    const normalize = (value: string) => (value || '').replace(/-/g, '').toLowerCase()
  
    const scaleConfigs = [
      // ── Sedation Scale ──────────────────────────────────────────────────────
      {
        vitalPath: 'sedationScale.selections',
        matcher: (item: any) => normalize(item.sectionLabel) === normalize('Agitation-Sedation'),
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.901',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: null,
        pnnvPath: null,
      },
  
      // ── COWS Criteria (eVitals.902–913) ─────────────────────────────────────
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.902',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.902',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.903',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.903',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.904',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.904',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.905',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.905',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.906',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.906',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.907',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.907',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.908',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.908',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.909',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.909',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.910',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.910',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.911',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.911',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
      {
        vitalPath: 'withdrawalScaleCriteria',
        matcher: (item: any) => item.element === 'eVitals.912',
        valueExtractor: (resolved: any) => String(resolved.score),
        isScalar: false,
        customElementId: null,
        customElementName: 'eVitals.912',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: null,
      },
  
      {
        vitalPath: 'withdrawalScaleTotal',
        matcher: null,
        valueExtractor: (resolved: any) => String(resolved),
        isScalar: true,
        customElementId: null,
        customElementName: 'eVitals.913',
        groupId: 'eVitals.VitalGroup',
        version: '3.5.0',
        mapToNemsis3: 0,
        elementNumber: null,
        scaleTypeGuard: (vital: any) => vital.withdrawalScaleType?.id === 13,
        pnnvPath: 'withdrawalScaleTotalPNNV',
      },
    ]
  
    if (!Array.isArray(regions) || regions.length === 0) return
    data.customData = data.customData || []
  
    const getByPath = (obj: any, path: string) =>
      path.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), obj)
  
    const buildResult = (selection: any, valueExtractor: (r: any) => string) => ({
      id: null,
      name: selection?.name ?? null,
      isPN: false,
      isNV: false,
      valueText: valueExtractor(selection),
    })
  
    const buildScalarResult = (selection: any, valueExtractor: (r: any) => string) => {
      if (selection == null || selection === '') return []
      return { valueText: valueExtractor(selection) }
    }
  
    const buildPNNV = (pnnvRaw: any) => {
      if (!pnnvRaw) return null
      return {
        id: pnnvRaw.id ?? null,
        name: pnnvRaw.name ?? null,
        pn: pnnvRaw.pn ?? String(pnnvRaw.id ?? ''),
        nv: pnnvRaw.nv ?? '',
      }
    }
  
    const getStateBucket = (stateName: string) => {
      let bucket = data.customData.find((c: any) => c.state === stateName)
      if (!bucket) {
        bucket = { state: stateName, stateResults: [] }
        data.customData.push(bucket)
      }
      return bucket
    }
  
    const vitals = data?.patient?.patientVitals || []
  
    vitals.forEach((vital: any, index: number) => {
      const sequence = index + 1
      const groupCorrelation = `eVitals.VitalGroup${sequence}`
  
      scaleConfigs.forEach(config => {
        if (config.scaleTypeGuard && !config.scaleTypeGuard(vital)) return
  
        const raw = getByPath(vital, config.vitalPath)
  
        const resolved = Array.isArray(raw)
          ? config.matcher ? raw.find(config.matcher) : undefined
          : raw

        const pnnv = config.pnnvPath ? getByPath(vital, config.pnnvPath) : null

        if ((resolved == null || resolved === '') && !pnnv) return
  
        const entry = {
          customElementId: config.customElementId,
          customElementName: config.customElementName,
          clientCorrelationId: `patient.patientVitals_${vital.key}`,
          originalDataPath: '',
          groupId: config.groupId,
          version: config.version,
          mapToNemsis3: config.mapToNemsis3,
          elementNumber: config.elementNumber,
          groupingSequence: sequence,
          groupCorrelation,
          results: config.isScalar
            ? buildScalarResult(resolved, config.valueExtractor)
            : buildResult(resolved, config.valueExtractor),
          resultsPNNV: buildPNNV(pnnv),
          _groupKey: vital.key,
        }
  
        regions.forEach(stateName => {
          getStateBucket(stateName).stateResults.push(entry)
        })
      })
    })
  }

  public static populateCustomDataForState(data: any, stateInitial: string) {
    let stateCustomDataArray: any = []
    let stateCustomDataObj: any = {}
    data.customDataMerged = {}

    if (data?.customData) {
      // copy state-specific custom data first
      stateCustomDataArray = data.customData
      stateCustomDataObj =
        stateCustomDataArray && stateCustomDataArray.length > 0
          ? stateCustomDataArray.find((item: any) => item.state === stateInitial)
          : {}

      if (stateCustomDataObj?.stateResults && stateCustomDataObj.stateResults.length > 0) {
        data.customDataMerged.stateResults = stateCustomDataObj.stateResults
      }

      // copy NEMSIS Nation custom data next
      stateCustomDataObj =
        stateCustomDataArray && stateCustomDataArray.length > 0
          ? stateCustomDataArray.find((item: any) => item.state === 'US')
          : {}

      if (stateCustomDataObj?.stateResults && stateCustomDataObj.stateResults.length > 0) {
        if (data.customDataMerged.stateResults && data.customDataMerged.stateResults.length > 0) {
          data.customDataMerged.stateResults?.push(stateCustomDataObj.stateResults)
        } else {
          data.customDataMerged.stateResults = stateCustomDataObj.stateResults
        }
      }
    }
  }

  // #endregion  for Schematron Pre-Run Rules Functions (e.g. PNNV autofill)

  //#region for XSD functions
  /*
  To be used by Required and Recommended fields to check:
  1. User input fields like text or date - Value or PNNV value
  2. Single select fields - Code for selected value or PNNV value
  3. Multi-select fields - PNNV value or codes for selected values
  */

  public static checkIfLeafNodeHasValue(jsonPath: string, jsonData: any) {
    // Parse JSON data
    //const parsedData = JSON.parse(jsonData);
    let leafNodeHasValue = true
    // Traverse JSON object based on JSON path
    jsonPath = jsonPath.replace('data.', '')
    const segments = jsonPath.split('.')
    let segmentsParsed = ''
    let currentValue: any = jsonData
    let parentValue = jsonData
    let parentIsArray = false
    let parentSegment

    //Check for filter values
    let filterString
    let filterValue: any = []
    let filterKey: any

    let isFilterExists = false

    if (jsonPath.includes('&')) {
      const parts = jsonPath.split('&')
      filterString = parts[1]
      const filterParts = filterString.split('=')
      filterKey = filterParts[0]
      filterValue = filterParts[1].split(',')
      isFilterExists = true
    }

    if (jsonPath.includes('symptoms')) {
      return RulesUtilsMaster.handleSymptomsHasValueCheck(jsonPath, jsonData)
    }

    for (const segment of segments) {
      segmentsParsed += '.' + segment

      if (jsonPath === segmentsParsed.substring(1, segmentsParsed.length)) {
        // Reached the end of the path
        const parentSegmentPNNV: any = parentSegment + 'PNNV'

        if (parentIsArray) {
          if (currentValue.hasOwnProperty(parentSegmentPNNV)) {
            leafNodeHasValue =
              RulesUtilsMaster.hasValue(currentValue[parentSegmentPNNV]['pn']) && isFilterExists
                ? filterValue.includes(currentValue[parentSegmentPNNV][filterKey].toString())
                : true
            if (leafNodeHasValue) {
              // For multi-selects we will have only one set of PN or NV. So if there is a PN or NV value we need not check for the
              // actual field data.
              return true
            }
          } else if (parentValue.hasOwnProperty(parentSegmentPNNV)) {
            leafNodeHasValue =
              RulesUtilsMaster.hasValue(parentValue[parentSegmentPNNV]['pn']) && isFilterExists
                ? filterValue.includes(parentValue[parentSegmentPNNV][filterKey].toString())
                : true
            if (leafNodeHasValue) {
              // For multi-selects we will have only one set of PN or NV. So if there is a PN or NV value we need not check for the
              // actual field data.
              return true
            }
          }

          if (currentValue.hasOwnProperty(parentSegmentPNNV)) {
            leafNodeHasValue =
              RulesUtilsMaster.hasValue(currentValue[parentSegmentPNNV]['nv']) && isFilterExists
                ? filterValue.includes(currentValue[parentSegmentPNNV][filterKey].toString())
                : true
            if (leafNodeHasValue) {
              // For multi-selects we will have only one set of PN or NV. So if there is a PN or NV value we need not check for the
              // actual field data.
              return true
            }
          } else if (parentValue.hasOwnProperty(parentSegmentPNNV)) {
            leafNodeHasValue =
              RulesUtilsMaster.hasValue(parentValue[parentSegmentPNNV]['nv']) && isFilterExists
                ? filterValue.includes(parentValue[parentSegmentPNNV][filterKey].toString())
                : true
            if (leafNodeHasValue) {
              // For multi-selects we will have only one set of PN or NV. So if there is a PN or NV value we need not check for the
              // actual field data.
              return true
            }
          }

          // For multi-selects we will have only one set of PN or NV. So if there is a PN or NV value we need not check for the
          // actual field data.
          for (const obj of currentValue) {
            if (obj.hasOwnProperty(segment)) {
              leafNodeHasValue =
                RulesUtilsMaster.hasValue(obj[segment]) && isFilterExists
                  ? filterValue.includes(obj[filterKey].toString())
                  : true
              if (!leafNodeHasValue) return false
            }
          }
        } else {
          // probably a field directly under root, like prid, pcrId or createdBy as well as single-select fields
          const segmentPNNV = segment + 'PNNV'

          if (currentValue.hasOwnProperty(segment)) {
            leafNodeHasValue = RulesUtilsMaster.hasValue(currentValue[segment])
            if (leafNodeHasValue && isFilterExists) {
              leafNodeHasValue = filterValue.includes(currentValue[filterKey].toString())
            }
          } else {
            leafNodeHasValue = false
          }

          if (!leafNodeHasValue) {
            if (currentValue.hasOwnProperty(segmentPNNV) && currentValue[segmentPNNV]) {
              leafNodeHasValue = RulesUtilsMaster.hasValue(currentValue[segmentPNNV]['pn'])
              if (leafNodeHasValue && isFilterExists) {
                leafNodeHasValue = filterValue.includes(currentValue[filterKey].toString())
              }
            } else if (parentValue.hasOwnProperty(parentSegmentPNNV) && parentValue[parentSegmentPNNV]) {
              leafNodeHasValue = RulesUtilsMaster.hasValue(parentValue[parentSegmentPNNV]['pn'])
              if (leafNodeHasValue && isFilterExists) {
                leafNodeHasValue = filterValue.includes(parentValue[parentSegmentPNNV][filterKey].toString())
              }
            }
          }

          if (!leafNodeHasValue) {
            if (currentValue.hasOwnProperty(segmentPNNV) && currentValue[segmentPNNV]) {
              leafNodeHasValue = RulesUtilsMaster.hasValue(currentValue[segmentPNNV]['nv'])
              if (leafNodeHasValue && isFilterExists) {
                leafNodeHasValue = filterValue.includes(currentValue[segmentPNNV][filterKey].toString())
              }
            } else if (parentValue.hasOwnProperty(parentSegmentPNNV) && parentValue[parentSegmentPNNV]) {
              leafNodeHasValue = RulesUtilsMaster.hasValue(parentValue[parentSegmentPNNV]['nv'])
              if (leafNodeHasValue && isFilterExists) {
                leafNodeHasValue = filterValue.includes(parentValue[parentSegmentPNNV][filterKey].toString())
              }
            }
          }

          /*currentValue = currentValue[segment];
          if (currentValue)
            leafNodeIsEmpty = false;
          */
        }
      } else {
        parentSegment = segment
        // Traversing through the path

        parentValue = currentValue
        currentValue = currentValue[segment]
        if (typeof currentValue === 'undefined') {
          return false
        }

        if (Array.isArray(currentValue)) {
          parentIsArray = true
        } else {
          parentIsArray = false
        }
      }
    }
    return leafNodeHasValue
  }

  public static checkIfLeafNodeIncludes(jsonPath: string, jsonData: any, values: any, isPNNV: boolean) {
    // Parse JSON data
    jsonPath = jsonPath.replace('data.', '')
    let leafNodeIncludes = true
    // Traverse JSON object based on JSON path
    const segments = jsonPath.split('.')
    let segmentsParsed = ''
    let currentValue = jsonData
    let currentPNNVValue = jsonData
    let currentPNNV = ''
    let parentIsArray = false

    for (const segment of segments) {
      segmentsParsed += '.' + segment
      currentPNNV = segment + 'PNNV'

      if (jsonPath === segmentsParsed.substring(1, segmentsParsed.length)) {
        // Reached the end of the path
        if (!isPNNV) {
          if (parentIsArray) {
            for (const sequenceObj of currentValue) {
              if (Array.isArray(sequenceObj)) {
                for (const obj of sequenceObj) {
                  if (obj.hasOwnProperty(segment)) {
                    if (RulesUtilsMaster.hasValue(obj[segment])) {
                      leafNodeIncludes =
                        leafNodeIncludes && RulesUtilsMaster.isFieldExistWithinList(jsonPath, obj, segment, values, isPNNV)
                    }
                  }
                }
              } else {
                if (sequenceObj.hasOwnProperty(segment)) {
                  if (RulesUtilsMaster.hasValue(sequenceObj[segment])) {
                    leafNodeIncludes =
                      leafNodeIncludes &&
                      RulesUtilsMaster.isFieldExistWithinList(jsonPath, sequenceObj, segment, values, isPNNV)
                  }
                }
              }
            }
          } else {
            if (RulesUtilsMaster.hasValue(currentValue[segment])) {
              leafNodeIncludes = RulesUtilsMaster.isFieldExistWithinList(jsonPath, currentValue, segment, values, isPNNV)
            }
          }
        } else {
          if (Array.isArray(currentPNNVValue)) {
            for (const sequenceObj of currentPNNVValue) {
              if (Array.isArray(sequenceObj)) {
                for (const obj of sequenceObj) {
                  if (RulesUtilsMaster.hasValue(obj)) {
                    leafNodeIncludes =
                      leafNodeIncludes && RulesUtilsMaster.isFieldExistWithinList(jsonPath, obj, segment, values, isPNNV)
                  }
                }
              } else {
                if (RulesUtilsMaster.hasValue(sequenceObj)) {
                  leafNodeIncludes =
                    leafNodeIncludes &&
                    RulesUtilsMaster.isFieldExistWithinList(jsonPath, sequenceObj, segment, values, isPNNV)
                }
              }
            }
          } else {
            if (!RulesUtilsMaster.hasValue(currentPNNVValue))
              currentPNNVValue = RulesUtilsMaster.hasValue(currentValue[currentPNNV + 's'])
                ? currentValue[currentPNNV + 's']
                : currentValue[currentPNNV]

            if (RulesUtilsMaster.hasValue(currentPNNVValue)) {
              leafNodeIncludes = RulesUtilsMaster.isFieldExistWithinList(jsonPath, currentPNNVValue, segment, values, isPNNV)
            }
          }
        }
      } else {
        // Traversing through the path
        if (currentValue) {
          if (Array.isArray(currentValue)) {
            const currentvalueArray: any = []
            const currentPNNVValueArray: any = []
            for (const obj of currentValue) {
              currentvalueArray.push(obj[segment])
              currentPNNVValueArray.push(
                RulesUtilsMaster.hasValue(obj[currentPNNV + 's']) ? obj[currentPNNV + 's'] : obj[currentPNNV]
              )
            }
            currentValue = currentvalueArray
            currentPNNVValue = currentPNNVValueArray
          } else {
            currentPNNVValue = RulesUtilsMaster.hasValue(currentValue[currentPNNV + 's'])
              ? currentValue[currentPNNV + 's']
              : currentValue[currentPNNV]
            currentValue = currentValue[segment]
          }
        }
        if (Array.isArray(currentValue)) {
          parentIsArray = true
        } else {
          parentIsArray = false
        }
      }
    }
    return leafNodeIncludes
  }

  public static checkForRestrictions(jsonPath: string, jsonData: any, restrictionType: string, restrictionValue: any) {
    // Traverse JSON object based on JSON path
    jsonPath = jsonPath.replace('data.', '')
    const segments = jsonPath.split('.')
    let segmentsParsed = ''
    let currentValue: any = jsonData
    let parentIsArray = false
    // if (jsonPath.includes("symptoms")) {
    //   return handleRestrictionsForSymptoms(jsonPath, jsonData)
    // }
    for (const segment of segments) {
      segmentsParsed += '.' + segment
      if (jsonPath === segmentsParsed.substring(1, segmentsParsed.length)) {
        // Reached the end of the path
        if (parentIsArray) {
          //const tempValues: any[] = []
          for (const obj of currentValue) {
            if (obj.hasOwnProperty(segment)) {
              if (!RulesUtilsMaster.restrictionIsSatisfied(restrictionType, restrictionValue, obj[segment])) {
                return false
              }
            }
          }
        } else {
          // probably a field directly under root, like prid, pcrId or createdBy
          currentValue = currentValue[segment]
          return RulesUtilsMaster.restrictionIsSatisfied(restrictionType, restrictionValue, currentValue)
        }
      } else {
        // Traversing through the path
        currentValue = currentValue[segment]
        if (Array.isArray(currentValue)) {
          parentIsArray = true
        } else {
          parentIsArray = false
        }
      }
    }
    return true
  }

  public static falsyExceptZero(valueToCheck: any) {
    return !valueToCheck && valueToCheck !== 0
  }

  static truthyOrZero(valueToCheck: any) {
    return !!valueToCheck || valueToCheck === 0
  }

  public static restrictionIsSatisfied(restrictionType: string, restrictionValue: any, actualValue: any) {
    let strippedValue: any
    let fractionValue: any
    let regex: any

    // Let actual value of 0 be evaluated within the switch/case below in case it's not valid
    if (this.falsyExceptZero(actualValue)) return true

    switch (restrictionType) {
      case 'Length':
        actualValue = actualValue.length
        if (actualValue !== restrictionValue) {
          return false
        }
        break
      case 'MinLength':
        actualValue = actualValue.length
        if (actualValue < restrictionValue) {
          return false
        }
        break
      case 'MaxLength':
        actualValue = actualValue.length
        if (actualValue > restrictionValue) {
          return false
        }
        break
      case 'TotalDigits':
        strippedValue = actualValue.replace(/^0+|\\.|0+$/g, '')
        if (strippedValue.length !== restrictionValue) {
          return false
        }
        break
      case 'FractionDigits':
        fractionValue = actualValue.split('.')[1]
        if (fractionValue.length > restrictionValue) {
          return false
        }
        break
      case 'MinInclusive':
        if (!this.evaluateExpression(actualValue, restrictionValue, '>=')) {
          return false
        }
        break
      case 'MaxInclusive':
        if (!this.evaluateExpression(actualValue, restrictionValue, '<=')) {
          return false
        }
        break
      case 'Pattern':
        regex = new RegExp(restrictionValue)
        if (!regex.test(actualValue)) {
          return false
        }
        break
    }
    return true
  }

  //Code to handle checks for MinInclusinve and MaxInclusive restriction types value
  public static evaluateExpression(
    actualValue: number | string | Date,
    restrictionValue: number | string | Date,
    operator: string
  ) {
    let result

    // string-with-dashes and string -> date and date
    if (restrictionValue.toString().includes('-') && typeof actualValue === 'string') {
      const splitRestriction = restrictionValue.toString().split('-')

      /* eslint-disable @typescript-eslint/no-unused-vars */
      const resMonth = parseInt(splitRestriction[1]) - 1
      const resDay = parseInt(splitRestriction[2])
      const resYear = parseInt(splitRestriction[0])

      if (
        splitRestriction[0].length == 4 &&
        splitRestriction[1].length == 2 &&
        splitRestriction[2].length == 2 &&
        MMDDYYYY.test(actualValue.toString())
      ) {
        result = eval(`new Date(actualValue) ${operator} new Date(resYear, resMonth, resDay)`)
      }

      // number and string-to-float
    } else if (typeof actualValue === 'number' && typeof restrictionValue === 'string') {
      result = eval(`actualValue ${operator} parseFloat(restrictionValue)`)

      // string and string -> float and float
    } else if (
      typeof actualValue === 'string' &&
      typeof restrictionValue === 'string' &&
      !isNaN(parseFloat(actualValue)) &&
      !isNaN(parseFloat(restrictionValue))
    ) {
      result = eval(`parseFloat(actualValue) ${operator} parseFloat(restrictionValue)`)

      // actualValue and restrictionValue
    } else {
      result = eval(`actualValue ${operator} restrictionValue`)
    }

    return result
  }

  public static handleSymptomsHasValueCheck(jsonPath: string, jsonData: any) {
    let leafNodeHasValue = true
    // Traverse JSON object based on JSON path
    const segments = jsonPath.split('.')
    const valueKey = segments[segments.length - 1] // Get the leaf node, here NEMSIS
    const symptomsSegmentData = jsonData['ccHpi']['symptoms']
    const parentSegmentData = jsonData['ccHpi']
    const segNameForSymptomsPNNV = 'symptomsPNNVs'

    if (jsonPath.includes('primarySymptom')) {
      // Check for Primary Symptom
      if (symptomsSegmentData.length) {
        // data available within symptoms object
        //const primarySymptom = primaryjsonData.ccHpi.symptoms.find(symptom => symptom.rank === 1);
        const primarySymptom = symptomsSegmentData.find((symptom: { rank: number }) => symptom.rank === 1)
        leafNodeHasValue = RulesUtilsMaster.hasValue(primarySymptom[valueKey])
      }
    } else {
      // Checks for Other Symptom
      if (symptomsSegmentData.length) {
        // data available within symptoms object
        //const primarySymptom = primaryjsonData.ccHpi.symptoms.find(symptom => symptom.rank === 99);
        const otherSymptoms = symptomsSegmentData.filter((symptom: { rank: number }) => symptom.rank === 99)
        if (otherSymptoms !== undefined && otherSymptoms.length > 0) {
          for (const obj of otherSymptoms) {
            leafNodeHasValue &&= RulesUtilsMaster.hasValue(obj[valueKey])
          }
        }
      }
      if (parentSegmentData.hasOwnProperty(segNameForSymptomsPNNV)) {
        const otherSymptoms = parentSegmentData[segNameForSymptomsPNNV].filter(
          (symptom: { rank: number }) => symptom.rank === 99
        )
        if (otherSymptoms !== undefined && otherSymptoms.length >= 0) {
          for (const obj of otherSymptoms) {
            leafNodeHasValue &&= RulesUtilsMaster.hasValue(obj[valueKey]) && RulesUtilsMaster.hasValue(obj['pn'])
          }
        }
      }
    }
    return leafNodeHasValue
  }

  public static isFieldExistWithinList(
    jsonPath: string,
    object: any,
    fieldName: string,
    listValues: any,
    isPNNV: boolean
  ) {
    let filterString
    let filterValue: any = []
    let filterKey: any

    let leafNodeIncludes = true
    //Get the filterfield and value
    if (jsonPath.includes('&')) {
      const parts = jsonPath.split('&')
      filterString = parts[1]
      const filterParts = filterString.split('=')
      filterKey = filterParts[0]
      filterValue = filterParts[1].split(',')
    }

    if (object[filterKey] && filterValue.includes(object[filterKey].toString())) {
      // TODO - we need to handle filter values
    } else {
      if (!isPNNV) {
        leafNodeIncludes = listValues.includes(object[fieldName].toString())
      } else {
        if (RulesUtilsMaster.hasValue(object['nv'])) {
          leafNodeIncludes = listValues.includes(object['nv'].toString())
        } else if (RulesUtilsMaster.hasValue(object['pn'])) {
          leafNodeIncludes = listValues.includes(object['pn'].toString())
        } else {
          leafNodeIncludes = false
        }
      }
    }

    return leafNodeIncludes
  }
  //#endregion for XSD functions

  public static hasValueForArray(obj: any) {
    for (const key in obj) {
      if (obj[key] !== null && typeof obj[key] === 'object') {
        // Recursively check nested objects
        if (RulesUtilsMaster.hasValue(obj[key])) {
          return true
        }
      } else if (obj[key] !== undefined && obj[key] !== null) {
        // Check if the current property has a non-empty value
        if (typeof obj[key] === 'string') {
          // For string values, normalize spaces
          if (RulesUtilsMaster.normalizeSpace(obj[key]) !== '') {
            return true
          }
        } else {
          // For numeric values, check if not undefined and not null
          return true
        }
      }
    }
    return false
  }

  /// Pass a json object and check if there is at least one datapoint that has a value.
  /// If yes returns true, else returns false
  public static hasValue(obj: any) {
    if (obj === undefined) {
      // Datapoint not available, skip check by returning true
      return false
    }

    if (obj !== null) {
      if (typeof obj === 'object') {
        // If the current property is an object, recursively check nested objects
        for (const key in obj) {
          if (this.hasValue(obj[key])) {
            return true
          }
        }
      } else if (typeof obj === 'string') {
        // For string values, normalize spaces
        return RulesUtilsMaster.normalizeSpace(obj) !== ''
      } else {
        // For other non-null, non-string values (including numeric), consider it as having a value
        return true
      }
    }
    return false
  }

  public static hasValueAtPath(data: any, path: string) {
    // Split the path into individual keys
    const keys = path.split('.')

    // Iterate through the keys to access the nested value
    let value = data
    for (const key of keys) {
      // Check if the key exists in the current object
      if (value.hasOwnProperty(key)) {
        value = value[key]
      } else {
        // If any key is missing, return false
        return false
      }
    }

    // Check if the final value is not undefined, not null, and not an empty string
    return value !== undefined && value !== null && RulesUtilsMaster.normalizeSpace(value) !== ''
  }

  public static normalizeSpace(inputString: string) {
    return inputString.trim().replace(/\s+/g, ' ')
  }

  public static filterNonEmptyNodes(jsonArray: any[]) {
    return jsonArray.filter((item) =>
      Object.values(item).some((value) => value !== null && value !== undefined && value !== '')
    )
  }

  public static checkIfAnyValueExists(objectArray: any[]) {
    let objectFound = false
    objectArray.forEach((object) => {
      if (object) objectFound = true
    })
    return objectFound
  }

  public static decimal(value: any) {
    return Number(value)
  }

  public static checkCastable(value: any, valuetype: any) {
    let dateValue
    switch (valuetype) {
      case 'integer':
        if (Number.isInteger(parseInt(value))) {
          return true
        } else {
          return false
        }
      case 'date':
        dateValue = DateTime.fromFormat(value, 'yyyy-MM-dd')
        if (!dateValue.isValid) {
          dateValue = DateTime.fromFormat(value, 'MM/dd/yyyy')
        }
        if (dateValue.isValid) {
          return true
        } else {
          return false
        }
      default:
        return true
    }
  }

  public static getValueByPath(data: any, path: string) {
    const parts = path.split('.')
    let current = data

    for (let i = 0; i < parts.length; i++) {
      current = current[parts[i]]
      if (current === undefined) {
        return undefined
      }
    }

    return current
  }

  public static getPNIncludedFlattenedArray(
    data: any,
    contextObject: any,
    childObjet: any,
    pnContextObject: any,
    pnChildObjet: any
  ) {
    const flattenedRealValueArray = RulesUtilsMaster.getFlattenedArray(data, contextObject, childObjet)
    const flattenedPNValueArray = RulesUtilsMaster.getPNFlattenedArray(data, pnContextObject, pnChildObjet)

    if (flattenedPNValueArray !== undefined) {
      return flattenedRealValueArray.concat(flattenedPNValueArray)
    } else {
      return flattenedRealValueArray
    }
  }

  public static getPNFlattenedArray(data: any, contextObject: string, childObject: string) {
    if (!data.patient[contextObject]) {
      return undefined
    }

    const flattenedArray = data.patient[contextObject].reduce((acc: any, item: any) => {
      const key: string = item.key
      const nestedChildData = item[childObject]

      const rest = RulesUtilsMaster.__rest(item, ['key', childObject])

      const nestedItems = nestedChildData.map((nestedItem: any) => {
        const nestedKey: string = nestedItem.key
        const nestedRest = RulesUtilsMaster.__rest(nestedItem, ['key'])
        return {
          key: key,
          nestedKey: nestedKey,
          ...rest,
          ...Object.fromEntries(
            Object.entries(nestedRest).map(([childKey, childValue]) => {
              return [`nested_${childKey}`, childValue]
            })
          ),
        }
      })
      return acc.concat(nestedItems)
    }, [])
    return flattenedArray
  }

  public static getFlattenedArray(data: any, contextObject: any, childObject: any) {
    const flattenedArray = data.patient[contextObject].reduce((acc: any, item: any) => {
      const key = item.key
      const nestedChildData = item[childObject]

      const rest = RulesUtilsMaster.__rest(item, ['key', childObject])

      const nestedItems = nestedChildData.map((nestedItem: any) => {
        const nestedKey = nestedItem.key
        const nestedRest = RulesUtilsMaster.__rest(nestedItem, ['key'])

        return {
          key: key,
          nestedKey: nestedKey,
          ...rest,
          ...Object.fromEntries(
            Object.entries(nestedRest).map(([childKey, childValue]) => {
              return [`nested_${childKey}`, childValue]
            })
          ),
        }
      })
      return acc.concat(nestedItems)
    }, [])
    return flattenedArray
  }

  public static __assign(t: any, rest: any): any {
    for (let s: any, i = 1, n: number = arguments.length; i < n; i++) {
      s = arguments[i]
      for (const p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
    }
    return t
  }

  public static __rest(s: any, e: string[]): any {
    const t: any = {}
    for (const p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p]
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (let i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i].toString()) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]]
      }
    return t
  }

  public static fieldHasValue(
    jsonData: any,
    key: string,
    filter: string | null = null,
    checkForEmpty = false,
    checkForSingleOccurence = false
  ) {
    let valueAvailable = true //assume we have the value
    if (checkForSingleOccurence) valueAvailable = false

    if (jsonData === undefined || jsonData === null) {
      // Data was not available
      valueAvailable = valueAvailable && false
    } else {
      if (Array.isArray(jsonData)) {
        if (jsonData.length === 0) valueAvailable = valueAvailable && false
      }
      if (filter === null && key.includes('.')) {
        const keyParts = key.split('.')

        if (Array.isArray(jsonData)) {
          for (const object of jsonData) {
            const nestedArray = object[keyParts[0].replace('?', '')]

            if (Array.isArray(nestedArray)) {
              if (checkForSingleOccurence) {
                if (nestedArray.some((nestedObject) => this.hasValue(nestedObject[keyParts[1]]))) {
                  valueAvailable = true
                  break
                }
              } else {
                if (nestedArray.length === 0 || nestedArray.some((nestedObject) => !this.hasValue(nestedObject[keyParts[1]]))) {
                  valueAvailable = valueAvailable && false
                }
              }
            } else {
              if (checkForSingleOccurence) {
                valueAvailable = valueAvailable || this.hasValue(this.getFieldData(nestedArray, keyParts[1]))
              }
              else if (!this.hasValue(this.getFieldData(nestedArray, keyParts[1]))) {
                valueAvailable = valueAvailable && false
              }
            }
          }
        } else {
          if (!this.hasValue(this.getFieldData(jsonData[keyParts[0]], keyParts[1]))) {
            valueAvailable = valueAvailable && false
          }
        }
      } else if (filter === null) {
        if (Array.isArray(jsonData)) {
          for (const object of jsonData) {
            if (key.includes('+')) {
              const keySplit = key.split('+')
              if (checkForSingleOccurence) {
                if (this.hasValue(object[keySplit[0]].concat(object[keySplit[1]]))) {
                  valueAvailable = true
                  break
                }
              } else {
                if (!this.hasValue(object[keySplit[0]].concat(object[keySplit[1]]))) {
                  valueAvailable = valueAvailable && false
                }
              }
            } else if (checkForSingleOccurence && this.hasValue(object[key])) {
              valueAvailable = true
              break
            } else if (!this.hasValue(object[key])) {
              valueAvailable = valueAvailable && false
            }
          }
        } else {
          if (key.includes('+')) {
            const keySplit = key.split('+')
            if (
              !this.hasValue(this.getFieldData(jsonData, keySplit[0]).concat(this.getFieldData(jsonData, keySplit[1])))
            ) {
              valueAvailable = valueAvailable && false
            }
          } else if (!this.hasValue(this.getFieldData(jsonData, key))) {
            valueAvailable = valueAvailable && false
          }
        }
      } else {
        const parts = filter.split('=')
        const filterKey = parts[0]
        const filterValue = parts[1]
        // Convert filterValue to an array if it contains commas
        const filterValues = filterValue.split(',')

        if (Array.isArray(jsonData)) {
          if (jsonData.length === 0) {
            valueAvailable = valueAvailable && false
          }

          for (const [i, object] of jsonData.entries()) {
            if (key.includes('+')) {
              const keySplit = key.split('+')
              if (filterValues.includes(object[filterKey]?.toString())) {
                valueAvailable = true //if filter is present assume we already the required value
                if (!this.hasValue(object[keySplit[0]].concat(object[keySplit[1]]))) {
                  valueAvailable = valueAvailable && false
                }
              }
            } else if (filterValues.includes(object[filterKey]?.toString())) {
              valueAvailable = true //if filter is present assume we have the required value
              let updatedKey = key
              if (key.includes('.')) {
                const keyParts = key.split('.')
                updatedKey = keyParts[keyParts.length - 1]
              }

              if (!this.hasValue(object[updatedKey])) {
                valueAvailable = valueAvailable && false
              }
            } else {
              valueAvailable = valueAvailable && false // set to false if the filter is not present
            }

            if (valueAvailable) break
          }
        } else {
          if (key.includes('+')) {
            const keySplit = key.split('+')
            if (filterValues.includes(this.getFieldData(jsonData, filterKey)?.toString())) {
              if (
                !this.hasValue(
                  this.getFieldData(jsonData, keySplit[0]).concat(this.getFieldData(jsonData, keySplit[1]))
                )
              ) {
                valueAvailable = valueAvailable && false
              }
            } else {
              valueAvailable = valueAvailable && false //set to false if filter is not present
            }
          } else if (filterValues.includes(this.getFieldData(jsonData, filterKey)?.toString())) {
            if (!this.hasValue(this.getFieldData(jsonData, key))) {
              valueAvailable = valueAvailable && false
            }
          }
        }
      }
    }
    return checkForEmpty ? !valueAvailable : valueAvailable
  }

  public static getFieldData(data: any, path: string) {
    return path
      .replace('?','')
      .split('.')
      .reduce((current, key) => (current ? current[key] : undefined), data)
      ?.toString()
  }

  public static fieldExists(jsonData: any, key: string, filter: string | null = null) {
    let fieldExists = false

    if (jsonData === undefined || jsonData === null) {
      // TODO: Data was not available, we should do something more than just return false when working on return object
      return fieldExists
    } else {
      if (filter == null) {
        if (Array.isArray(jsonData)) {
          jsonData.forEach((object) => {
            if (object[key] !== undefined) {
              fieldExists = true
            }
            if (key.includes('.')) {
              if (this.keyExists(object, key)) {
                fieldExists = true
              }
            }
          })
        } else {
          if (this.keyExists(jsonData, key)) {
            fieldExists = true
          }
        }
      } else {
        const parts = filter.split('=')
        const filterKey = parts[0]
        const filterValue = parts[1]
        const filterValues = filterValue.split(',')
        if (Array.isArray(jsonData)) {
          jsonData.forEach((object) => {
            if (
              object[key] !== undefined &&
              !this.falsyExceptZero(object[filterKey]) &&
              filterValues.includes(object[filterKey].toString())
            ) {
              fieldExists = true
            }
          })
        } else {
          if (this.keyExists(jsonData, key) && filterValues.includes(this.getFieldData(jsonData, filterKey))) {
            fieldExists = true
          }
        }
      }
    }
    return fieldExists
  }

  public static keyExists(data: any, path: string) {
    return (
      path.split('.').reduce((current, key) => {
        if (current && key in current) {
          return current[key] // Move to the next level in the path
        }
        return false // If the key doesn't exist, return false
      }, data) !== false
    ) // Return true if the key exists, false otherwise
  }

  public static valueInList(jsonData: any, lookupList: any[], key: string, filter: string | null = null) {
    let objectFound = false
    lookupList = lookupList.map(String)

    if (jsonData === undefined || jsonData === null) {
      // TODO: Data was not available, we should do something more than just return false when working on return object
      return objectFound
    }
    const checkMatch = (value: any, lookupList: any[]): boolean => {
      const valueStr = value.toString()
      const isValueInt = Number.isInteger(Number(valueStr))
      const matchingLookup = lookupList?.find(match => {
        const lookupIsInt = Number.isInteger(Number(match))
        if (lookupIsInt && isValueInt) {
          return Number(match) === Number(valueStr)
        }
        return match === valueStr
      })
      return matchingLookup !== undefined
    }

    if (filter === null) {
      if (Array.isArray(jsonData)) {
        if (key.includes('.')) {
          const keyParts = key.split('.')
          jsonData.forEach((object) => {
            //if our key contains path like medication?.id
            //remove question mark to read the data
            const nestedArray = object[keyParts[0].replace('?', '')]
            if (Array.isArray(nestedArray)) {
              nestedArray.forEach((nestedObject) => {
                if (lookupList?.includes(nestedObject[keyParts[1]].toString())) {
                  objectFound = true
                }
              })
            } else {
              if (nestedArray && nestedArray[keyParts[1]] && lookupList?.includes(nestedArray[keyParts[1]].toString())) objectFound = true
            }
          })
        } else {
          jsonData.forEach((object) => {
            if (object[key] !== undefined && object[key] !== null) {
              if (checkMatch(object[key], lookupList)) {
                objectFound = true
              }
            }
            else objectFound = false
          })
        }
      } else {
        if (jsonData[key] !== undefined && jsonData[key] !== null) {
          const val = jsonData[key]
          const valStr = val?.toString()
          const isValInt = Number.isInteger(Number(valStr))
          const found = lookupList?.some(match => {
            const isLookupInt = Number.isInteger(Number(match))
            return isValInt && isLookupInt
              ? Number(valStr) === Number(match)
              : valStr === match?.toString()
          })
          if (found) {
            objectFound = true
          }
        }
      }
    } else {
      const filterValue = filter.split('=')[1]
      const filterKey = filter.split('=')[0]
      const filterValues = filterValue.split(',')
      if(Array.isArray(jsonData)){
        jsonData.forEach((object: any) => {
          if (object[key] !== null) {
            if (lookupList?.includes(object[key].toString()) && filterValues.includes(object[filterKey].toString())) {
              if (checkMatch(object[key], lookupList)) {
                objectFound = true
              }
            }
          }
        })
      }
      else {
        if(key.includes('.')){
          const keyParts = key.replace('?','').split('.')
          if(jsonData[keyParts[0]] && jsonData[keyParts[0]][keyParts[1]]){
            const value = jsonData[keyParts[0]][keyParts[1]]
            if(lookupList?.includes(value.toString()) && filterValues.includes(jsonData[filterKey].toString())){
              if(checkMatch(value,lookupList)){
                objectFound = true
              }
            }
          }
        }
        else {
          if(jsonData[key] !== null){
            if(lookupList?.includes(jsonData[key].toString()) && filterValues.includes(jsonData[filterKey].toString())) {
              if (checkMatch(jsonData[key], lookupList)) {
                objectFound = true
              }
            }
          }
        }
      }
      
    }

    return objectFound
  }

  public static valueNotInList(jsonData: any, lookupList: any[], key: string, filter: string | null = null) {
    return !this.valueInList(jsonData, lookupList, key, filter)
  }

  //#region for count functions
  /*
    Attempts to get either (depending on the input parameters):
    1. number of occurences of the multi-frequency field by counting the array object
    2. number of occurences of the multi-frequency field that contain the desired value (given in the codeVal parameter)
    3. number of occurences of the multi-frequency field that contain the desired value (given in the codeVal parameter) while also matching the filter criteria
    4. Number of occurences of a field under multi-frequency group, where the field contains some specific text. Sample given below:
        Ex schematron rule: count(../../../nem:eSituation/nem:eSituation.PatientComplaintGroup[(contains(nem:eSituation.04, 'febrile'))]) &gt; 0
        our js: RulesUtilsMaster.count(data.situation,null,null,'complaint=febrile')>0)
    /// <param name='data'>json object data or could be boolean as well</param>
    /// <param name='codeVal'>could be a single value or comma-separated list of values or can be null</param>
    /// <param name='key'>We have 2 possibilities -
    //        1. leaf object identifying the NEMSIS field, ex: id or nemsis etc
    //        2. parentObject.LeafObject like "user?.id"</param>
    /// <param name='filterPath'>filter condition ex: segmentId=1/param>
    */

  public static count(
    data: any,
    codeVal: string | null = null,
    key: string | null = null,
    filter: string | null = null
  ) {
    if (typeof data === 'boolean') return data ? 99 : 0

    if (!data || this.checkPNNVKey(data)) return 0

    //Checks count(data.patient.patientDemographics.barriersToCare)===1
    if (!codeVal && !key) return data.length

    let codeVals: any = []
    if (key != null) {
      if (filter === null && codeVal === null) {
        return this.countWithCodeValAsPath(data, key)
      }
    }
    if (codeVal != null)
      codeVals = codeVal.split(',')


    //Checks count(data.factorsAffectingCareState.sceneFactors,'2210001,2210002,2210003','id')===0
    if (filter === null && key !== null) {
      let count = 0
      for (let j = 0; j < data.length; j++) {
        // Checks count(data.crew,'2403011,2403013','roles.id')<1
        if (key.includes('.')) {
          const keyParts = key.split('.')
          if (keyParts.length <= 2) {
            const nestedArray = data[j][keyParts[0]]
            if (nestedArray) {
              if (Array.isArray(nestedArray)) {
                nestedArray.forEach((nestedObject) => {
                  if (codeVals.includes(nestedObject[keyParts[1]]?.toString())) {
                    count = count + 1
                  }
                })
              } else {
                if (codeVals.includes(nestedArray[keyParts[1]]?.toString())) {
                  count = count + 1
                }
              }
            }
          } else {
            const leafValues = this.resolveNestedValues(data[j], keyParts)
            leafValues.forEach((val: any) => {
              if (val !== null && val !== undefined && codeVals.includes(val.toString())) {
                count = count + 1
              }
            })
          }
        } else {
          const arrayElement = data[j][key] //Add the endpoint Eg. .id or .nemsisCode and check array element against RHS values
          if (arrayElement !== null && arrayElement !== undefined) {
            if (codeVals.includes(arrayElement.toString())) {
              count = count + 1
            }
          }
        }
      }

      return count
    }

    // count(data.diagnosis.impressions, 'I63.9,G81.90,G45.9', 'nemsisCode', 'segmentId=1')
    // count(data?.additionalAssessment?.bodySurveys, null, 'examValues', 'locationId=14,15,16,17,18,19,85'
    // count(data?.additionalAssessment?.bodySurveys[0], null, 'examValues', 'locationId=14,15,16,17,18,19,85')
    if (filter !== null && key !== null) {
      return this.countWithFilter(data, codeVals, key, filter)
    }
  }

  // Recursively fetch all leaf values at a nested path, going through
  // both objects and arrays at each level.
  private static resolveNestedValues(obj: any, parts: string[]): any[] {
    if (!obj || parts.length === 0) return []

    const current = obj[parts[0]]
    if (current === null || current === undefined) return []

    if (parts.length === 1) return [current]

    const remaining = parts.slice(1)

    if (Array.isArray(current)) {
      return current.reduce((acc: any[], item: any) => {
        return acc.concat(this.resolveNestedValues(item, remaining))
      }, [])
    }

    return this.resolveNestedValues(current, remaining)
  }

  // count(data?.patient?.patientVitals, 'glucose')
  // count(data?.patient?.patientVitals, 'totalGCSScore')
  // count(data?.patient?.patientAllergies?.allergiesPNNV, 'pn.nv')
  // count(data?.patient?.patientVitals, 'eyeOpeningResponse.id')
  // count(data?.patient?.patientVitals, 'gcsQualifier.id')  
  public static countWithCodeValAsPath(array: any[], codeVal: string) {
    if (Array.isArray(array)) {
      return array.reduce((cnt, item) => {
        const keys = codeVal.split('.')

        // Case 1: sibling keys (e.g. 'pn.nv') or leaf node(e,g, glucose (or) totalGCSScore)
        if (keys.length === 1 || (keys.length === 2 && item[keys[0]] !== undefined && item[keys[1]] !== undefined)) {
          const count = keys.reduce(
            (innerCnt, key) => (item[key] && item[key] !== '' && item[key].toString().length > 0 ? innerCnt + 1 : innerCnt),
            0
          )
          return count > 0 ? cnt + 1 : cnt
        }

        // Case 2: nested child (e.g. 'gcsQualifier.id')
        if (keys.length === 2) {
          const [parentKey, childKey] = keys
          const parent = item[parentKey]

          if (Array.isArray(parent)) {
            // Check if any element in the array has the childKey with non-empty value
            const matchCount = parent.reduce((subCnt, el) => {
              const val = el?.[childKey]
              return val !== undefined && val !== '' && val.toString().length > 0 ? subCnt + 1 : subCnt
            }, 0)

            return cnt + matchCount
          } else if (typeof parent === 'object' && parent !== null) {
            // Just a single object
            const val = parent[childKey]
            if (val && val !== '' && val.toString().length > 0) {
              return cnt + 1
            }
          }
        }

        return cnt
      }, 0)
    } else {
      if (Array.isArray(array[codeVal.replace('?.', '.').split('.')[0]])) {
        const [arrKey, propKey] = codeVal.replace('?.', '.').split('.')
        return (array[arrKey] as any[]).reduce((cnt, item) => (item[propKey] && item[propKey] !== '' ? cnt + 1 : cnt),0)
      } else {
        return codeVal.replace('?.', '.').split('.')
          .reduce((cnt, key) => (array[key] && array[key] !== '' ? cnt + 1 : cnt), 0)
      }
    }
  }

  /*
    Attempts to get either the number of occurences of a multi-select field that contain the desired value (by checking against lookupList) 
    while also matching the filter criteria.
    There is also a variation where only jsonArray and filter are passed a value. This is for doing the count based on contains check.  
    Refer scenario 4 described in count function summary
    /// <param name='array'>json object data, an array of the NEMSIS\PCR field being checked</param>
    /// <param name='codeVal'>the list of values to check against for each occurence of the field</param>
    /// <param name='key'><param name='key'>We have 2 possibilities -
    //        1. leaf object identifying the NEMSIS field, ex: id or nemsis etc
    //        2. parentObject.LeafObject like "user?.id"</param>
    /// <param name='filterPath'>full path with filter condition ex: segmentId=1/param>
    */
  public static countWithFilter(array: any[], codeVal: any, key: string, filter: string) {
    const filterValue = filter.split('=')[1]
    filter = filter.split('=')[0]
    const filterValues = filterValue.split(',')
    if (key === null) {
      return array.reduce((count, item) => {
        return item[filter].contains(filterValue) ? count + 1 : count
      }, 0)
    }

    if (array[0] && array[0][key] && Array.isArray(array[0][key])) {
      // added a condition like 'array[0][key]' to check the key inside the object is array
      let totalCount = 0
      array.forEach((obj) => {
        totalCount += obj[key].reduce((count: number, item: any) => {
          if (filterValues.includes(item[filter].toString())) {
            return count + 1
          }
          return count
        }, 0)
      })
      return totalCount
    } else if (!Array.isArray(array) && Array.isArray(array[key])) {
      // RulesUtils.count(data?.additionalAssessment?.bodySurveys[0], null, 'examValues', 'locationId=14,15,16,17,18,19,85')
      let totalCount = 0
      const innerArray = array[key] as any[]
      if (innerArray) {
        innerArray.forEach(item => {
          if (filterValues.includes(item[filter].toString())) {
            totalCount++
          }
        })
      }
      return totalCount
    } else {
      return array.reduce((count, item) => {
        filterValues.map(String)
        if (filterValues.includes(item[filter].toString())) {
          return codeVal.length < 1 || codeVal.includes(item[key]) ? count + 1 : count
        }
        return count
      }, 0)
    }
  }
  //#endregion for count functions

  public static isNullOrEmpty(value: any) {
    return value == null || value === ''
  }

  public static matchesWithFilter(jsonData: any, regex: any, filter: any, key: any) {
    const filterKey = filter.split('=')[0]
    const filterValues = filter.split('=')[1].split(',')
    if (Array.isArray(jsonData)) {
      for (let j = 0; j < jsonData.length; j++) {
        if (filterValues.includes(jsonData[j][filterKey]?.toString())) {
          if (regex.test(jsonData[j][key])) {
            return true
          }
        }
      }
    } else {
      if (
        filterValues.includes(this.getFieldData(jsonData, filterKey)) &&
        regex.test(this.getFieldData(jsonData, key))
      ) {
        return true
      }
    }
    return false
  }

  public static matches(data: any, pattern: string, filter: any = null, key: any = null, checkForSingleOccurence = true, isLikeCheckForAllRecords = true) {
    if (data === undefined || data === null) {
      return false
    }
    const regex = new RegExp(pattern)
    if (this.isNullOrEmpty(filter)) {
      if (this.isNullOrEmpty(key)) {
        if (regex.test(data.toString())) {
          return true
        }
      } else {
        if (Array.isArray(data)) {
          for (let j = 0; j < data.length; j++) {
            if (key.includes('.')) {
              const keyParts = key.split('.')
              const obj = data[j][keyParts[0].replace('?','')]
              if (obj) {
                if(Array.isArray(obj)){
                  for(let i=0; i < obj.length; i++){
                    const element = obj[i][keyParts[1]]
                    if(checkForSingleOccurence && regex.test(element)) {
                      return true
                    }
                    else if(!checkForSingleOccurence && ((isLikeCheckForAllRecords && !regex.test(element)) || (!isLikeCheckForAllRecords && regex.test(element)))) {
                      return (isLikeCheckForAllRecords) ? false : true
                    }
                  }
                }
                else {
                  const element = obj[keyParts[1]]
                  if (checkForSingleOccurence && regex.test(element)) {
                    // Even one match for a multi-frequency field is good.
                    return true
                  }
                  else if (!checkForSingleOccurence && ((isLikeCheckForAllRecords && !regex.test(element)) || (!isLikeCheckForAllRecords && regex.test(element)))){
                    return (isLikeCheckForAllRecords) ? false : true
                  }
                }
              }
            } else {
              const arrayElement = data[j][key] //Add the leafnode Ex: id or nemsisCode and check regex expression against each element
              if (checkForSingleOccurence && regex.test(arrayElement)) {
                // Even one match for a multi-frequency field is good.
                return true
              }
              else if (!checkForSingleOccurence && ((isLikeCheckForAllRecords && !regex.test(arrayElement)) || (!isLikeCheckForAllRecords && regex.test(arrayElement)))){
                return (isLikeCheckForAllRecords) ? false : true
              }
            }
          }
        } else {
          const element = data[key]
          if (regex.test(element)) {
            return true
          }
          else {
            return false
          }
        }
      }
      return (checkForSingleOccurence) ? false : (isLikeCheckForAllRecords) ? true : false
    } else {
      // Multi frequency or single frequency field with filter and key values
      return this.matchesWithFilter(data, regex, filter, key)
    }
  }

  // #region date and time functions

  public static dateTime(dateTime: any) {
    if (dateTime === '') {
      return DateTime.fromISO('1800-01-01T12:00:00+00:00')
    }

    return DateTime.fromISO(dateTime)
  }

  public static dateTimeCombine(date: any, timeZoneOffset: string) {
    if (!date) return ''
    if (Number.isNaN(date)) return ''
    
    if (DateTime.fromFormat(date, 'MM/dd/yyhh:mm:ss').isValid) {
      return DateTime.fromFormat(date, 'MM/dd/yyhh:mm:ss', { zone: `UTC${timeZoneOffset}` }).toISO({
        includeOffset: true,
        suppressMilliseconds: true,
      })
    } else if (DateTime.fromFormat(date, 'MM/dd/yyyy hh:mm').isValid) {
      return DateTime.fromFormat(date, 'MM/dd/yyyy hh:mm', { zone: `UTC${timeZoneOffset}` }).toISO({
        includeOffset: true,
        suppressMilliseconds: true,
      })
    } else if (DateTime.fromFormat(date, 'MM/dd/yy hh:mm').isValid) {
      return DateTime.fromFormat(date, 'MM/dd/yy hh:mm', { zone: `UTC${timeZoneOffset}` }).toISO({
        includeOffset: true,
        suppressMilliseconds: true,
      })
    }else if (this.strictParse(date, 'MM/dd/yy')) {
      return DateTime.fromFormat(date, 'MM/dd/yy', { zone: `UTC${timeZoneOffset}` }).toISO({
        includeOffset: true,
        suppressMilliseconds: true,
      })
    } else if (DateTime.fromFormat(date, 'yyyy-MM-ddHH:mm:ss').isValid){
      return DateTime.fromFormat(date, 'yyyy-MM-ddHH:mm:ss', { zone: `UTC${timeZoneOffset}` }).toISO({
        includeOffset: true,
        suppressMilliseconds: true,
      })
    } else if (this.strictParse(date, 'MM/dd/yyyy')) {
      return DateTime.fromFormat(date, 'MM/dd/yyyy').toFormat('yyyy-MM-dd')
    } else {
      return ''
    }
  }

  public static strictParse(date: any, format : any) 
  {
    const dt = DateTime.fromFormat(date, format)
    // Check: Does the character count match exactly?
    if (dt.isValid && date.length === format.length) { return true }
    return false
  }

  public static compareDateTimes(lhsDateTime: any, rhsDateTime: any = null, operator: any, diffCompVal: any = null, diffUnit: any = null) {

    const lhsDateTimeBlank = (lhsDateTime === null || lhsDateTime === undefined || lhsDateTime === '')
    const rhsDateTimeBlank = (rhsDateTime === null || rhsDateTime === undefined || rhsDateTime === '')

    if (operator !== 'IS_NOT_NULL') {
      if (operator === 'IS_NULL' && !lhsDateTimeBlank)
        return false
      if (lhsDateTimeBlank || rhsDateTimeBlank) // For comparison both sides should have the data else don't trigger the rule
        return true
    }
    else if (operator === 'IS_NOT_NULL' && lhsDateTimeBlank)
      return false

    const lhsTotalMillseconds = lhsDateTime !== '' && lhsDateTime != null ? new Date(lhsDateTime).getTime() : null
    const rhsTotalMilliseconds = rhsDateTime !== '' && rhsDateTime != null ? new Date(rhsDateTime).getTime() : null

    // Declare the variable that will hold the MINUS comparison value
    let diffMilliseconds: number | null = null

    if (!operator) {
      return false
    }

    switch (operator) {
      case 'IS_NOT_NULL':
        return lhsTotalMillseconds != null

      case 'IS_NULL':
        return lhsTotalMillseconds == null

      case 'EQUAL':
        return lhsTotalMillseconds == rhsTotalMilliseconds

      case 'NOT_EQUAL':
        return lhsTotalMillseconds !== rhsTotalMilliseconds

      case 'MINUS':
        // MINUS per web, if there is no diff value it always returns false
        if (!diffCompVal || !diffUnit) {
          return false
        }
        // MINUS per web, if there is no right or left value for a datapoint it always returns true
        if (lhsTotalMillseconds == null || rhsTotalMilliseconds == null) {
          return true
        }
        diffMilliseconds = Math.abs(lhsTotalMillseconds - rhsTotalMilliseconds)

        // MINUS per web, always evaluates the dateTime difference as being less-than x amount of minutes: ((dt1 - dt2) < minutesDifferenceNumber) == true
        return ((diffMilliseconds / (1000 * 60)) < diffCompVal)

      case 'LESS_THAN':
        if (lhsTotalMillseconds == null || rhsTotalMilliseconds == null) return false
        return lhsTotalMillseconds < rhsTotalMilliseconds

      case 'LESS_THAN_OR_EQUAL':
        if (lhsTotalMillseconds == null || rhsTotalMilliseconds == null) return false
        return lhsTotalMillseconds <= rhsTotalMilliseconds

      case 'GREATER_THAN':
        if (lhsTotalMillseconds == null || rhsTotalMilliseconds == null) return false
        return lhsTotalMillseconds > rhsTotalMilliseconds

      case 'GREATER_THAN_OR_EQUAL':
        if (lhsTotalMillseconds == null || rhsTotalMilliseconds == null) return false
        return lhsTotalMillseconds >= rhsTotalMilliseconds

      default:
        return false
    }
  }

  public static compareDateTimesWithMultiplicity(lhsDateTimeArray: any, rhsDateTimeArray: any = null,
    operator: any, diffCompVal: any = null, diffUnit: any = null,
    lhsKey: any = null, timeZoneOffset: any = null, rhsKey: any = null, checkEachRow = false) {

    const lhsDateTimeArrayBlank = (lhsDateTimeArray === null || lhsDateTimeArray === undefined || lhsDateTimeArray === '' || lhsDateTimeArray.length === 0)
    const rhsDateTimeArrayBlank = (rhsDateTimeArray === null || rhsDateTimeArray === undefined || rhsDateTimeArray === '' || rhsDateTimeArray.length === 0)

    if (operator !== 'IS_NOT_NULL') {
      if (operator === 'IS_NULL' && !lhsDateTimeArrayBlank)
        return false
      if (lhsDateTimeArrayBlank || rhsDateTimeArrayBlank) // For comparison both sides should have the data else don't trigger the rule
        return true
    }
    else if (operator === 'IS_NOT_NULL' && lhsDateTimeArrayBlank)
      return false

    let lhsDateKey = lhsKey
    let lhsTimeKey = null
    let rhsDateKey = rhsKey
    let rhsTimeKey = null
    if (lhsKey !== null && lhsKey.includes('.')) {
      lhsDateKey = lhsKey.split('.')[0]
      lhsTimeKey = lhsKey.split('.')[1]
    }

    if (rhsKey !== null && rhsKey.includes('.')) {
      rhsDateKey = rhsKey.split('.')[0]
      rhsTimeKey = rhsKey.split('.')[1]
    }

    // When LHS DateTime field involves multiplicity but RHS DateTime field does not involve multiplicity.
    if (rhsKey === null) {
      for (const object of lhsDateTimeArray) {
        const lhsObject = this.dateTimeCombine(((lhsTimeKey != null) ? object[lhsDateKey] + object[lhsTimeKey] : object[lhsDateKey]), timeZoneOffset)
        if (!checkEachRow && this.compareDateTimes(lhsObject, rhsDateTimeArray, operator, diffCompVal, diffUnit)) {
          return true
        }
        else if (checkEachRow && !this.compareDateTimes(lhsObject, rhsDateTimeArray, operator, diffCompVal, diffUnit)) {
          return false
        }
      }
    }
    else {
      // When LHS and RHS, both involve multiplicity
      if (Array.isArray(lhsDateTimeArray)) {
        for (const object of lhsDateTimeArray) {
          const lhsObject = this.dateTimeCombine(((lhsTimeKey != null) ? object[lhsDateKey] + object[lhsTimeKey] : object[lhsDateKey]), timeZoneOffset)
          for (const rhsObject of rhsDateTimeArray) {
            const compVal = this.dateTimeCombine(((rhsTimeKey != null) ? rhsObject[rhsDateKey] + rhsObject[rhsTimeKey] : rhsObject[rhsDateKey]), timeZoneOffset)
            if (!checkEachRow && this.compareDateTimes(lhsObject, compVal, operator, diffCompVal, diffUnit)) {
              return true
            }
            else if (checkEachRow && !this.compareDateTimes(lhsObject, compVal, operator, diffCompVal, diffUnit)) {
              return false
            }
          }
        }
      }
      // When LHS does not involve multiplicity but RHS involves multiplicity
      else {
        for (const rhsObject of rhsDateTimeArray) {
          const compVal = this.dateTimeCombine(((rhsTimeKey != null) ? rhsObject[rhsDateKey] + rhsObject[rhsTimeKey] : rhsObject[rhsDateKey]), timeZoneOffset)
          if (!checkEachRow && this.compareDateTimes(lhsDateTimeArray, compVal, operator, diffCompVal, diffUnit)) {
            return true
          }
          else if (checkEachRow && !this.compareDateTimes(lhsDateTimeArray, compVal, operator, diffCompVal, diffUnit)) {
            return false
          }
        }
      }
    }
    return (checkEachRow) ? true : false //If checkEachRow is true and we are falling here, it means the check has not failed above, hence true
  }

  public static addMinsToDate(dateval: any, mins: any) {
    let newDate = DateTime.fromISO(dateval)
    newDate = newDate.plus({ minutes: mins })
    return newDate
  }

  public static currentDate() {
    return DateTime.now().toISO({ includeOffset: true, suppressMilliseconds: true })
  }

  public static dayTimeDuration(value: string) {
    const durationString = value.replace('PT', '')
    const hour = Number(durationString.substring(0, durationString.indexOf('H')))
    const mins = !durationString.includes('M')
      ? 0
      : Number(durationString.substring(durationString.indexOf('H') + 1, durationString.indexOf('M')))
    const addMins = hour * 60 + mins
    return addMins
  }

  public static daysFromDuration(diffInMilliseconds: number) {
    const diffInDays = Math.floor(Math.abs(diffInMilliseconds / (1000 * 60 * 60 * 24)))
    return diffInDays
  }

  public static hoursFromDuration(diffInMilliseconds: number) {
    const wholeHours = Math.trunc(diffInMilliseconds / (1000 * 60 * 60))
    const wholeDays = Math.trunc(wholeHours / 24)
    const diffInHours = wholeHours - (wholeDays * 24)
    return diffInHours
  }

  public static minutesFromDuration(diffInMilliseconds: number) {
    const wholeMinutes = Math.trunc(diffInMilliseconds / (1000 * 60))
    const wholeHours = Math.trunc(wholeMinutes / 60)
    const minutes = wholeMinutes - (wholeHours * 60)
    return minutes
  }

  public static secondsFromDuration(diffInMilliseconds: number) {
    const wholeSeconds = Math.trunc(diffInMilliseconds / 1000)
    const wholeMinutes = Math.trunc(wholeSeconds / 60)
    const seconds = wholeSeconds - (wholeMinutes * 60)
    return seconds
  }

  public static date(dateToFormat: string) {
    let dt = DateTime.fromFormat(dateToFormat, 'MM/dd/yyyy')

    //if the above format is not valid, try to parse it using ISO
    if (!dt.isValid) {
      dt = DateTime.fromISO(dateToFormat)
    }

    //if the date is still not valid, return null
    if (!dt.isValid) {
      return null
    }
    //Convert to nemsis expected date format
    const formattedDate = dt.toFormat('yyyy-MM-dd')
    return formattedDate
  }

  public static adjustDateTimeToTimezone(dateTimeValue: any) {
    return DateTime.fromISO(dateTimeValue).toUTC().toISO()
  }

  public static formatDateTime(dateTime: any, format: string) {
    const luxonFormat = format
      .replace(/\[Y0001\]/g, 'yyyy') // [Y0001] → yyyy for years
      .replace(/\[M01\]/g, 'MM') // [M01] → MM for months
      .replace(/\[D01\]/g, 'dd') // [D01] → dd for date
      .replace(/\[H01\]/g, 'HH') // [H01] → HH for 2-digit hour
      .replace(/\[m01\]/g, 'mm') // [m01] → mm for 2-digit minute
      .replace(/\[s01\]/g, 'ss') // [s01] → ss for 2-digit second

    const dateTimeValue = DateTime.fromISO(dateTime).toUTC()
    return dateTimeValue.toFormat(luxonFormat)
  }

  // #endregion date and time functions

  public static checkPNNVKey(baseArray: any[]): boolean {
    let hasPNNVKey = false
    if (Array.isArray(baseArray)) {
      hasPNNVKey = baseArray.some((obj: any) => (obj.hasOwnProperty('pn') && obj.pn != null) || (obj.hasOwnProperty('nv') && obj.nv != null))
    }
    return hasPNNVKey
  }

  public static pushToArray(data: any, baseArrayPath: string, objToPushPath: string) {
    const pathParts = baseArrayPath.split('.')
    let current = data

    for (let i = 0; i < pathParts.length; i++) {
      const key = pathParts[i]
      if (i === pathParts.length - 1) {
        if (!current[key])
          current[key] = []
      }
      current = current[key]
    }
    const baseArray = current
    const objToPush: any = objToPushPath.split('.').reduce((obj: any, key: string) => obj && obj[key], data)
    let hasPNNVKey = false

    if (Array.isArray(baseArray) && objToPush) {
      hasPNNVKey = this.checkPNNVKey(baseArray)
      if (!hasPNNVKey) baseArray.push(objToPush)
    }
  }

  public static removeFromArray(data: any, baseArrayPath: string) {
    const baseArray: any[] | undefined = baseArrayPath.split('.').reduce((obj, key) => obj && obj[key], data)
    if (Array.isArray(baseArray) && this.checkPNNVKey(baseArray)) {
      baseArray.pop()
    }
  }

  //#region for string functions
  public static substring(field: string, startIndex: number, lengthOfString: number) {
    return field.substring(startIndex - 1, lengthOfString + (startIndex - 1))
  }

  public static startsWith(jsonData: any, checkForString: any, key: any = null, filter: any = null) {
    if (!key && !filter) {
      return jsonData && jsonData.startsWith(checkForString)
    }
    else {
      if (filter) {
        const filterKey = filter.split('=')[0]
        const filterValues = filter.split('=')[1].split(',')
        if (Array.isArray(jsonData)) {
          for (let j = 0; j < jsonData.length; j++) {
            if (filterValues.includes(jsonData[j][filterKey]?.toString())) {
              if (jsonData[j][key].startsWith(checkForString)) {
                return true
              }
            }
          }
        } else {
          if (
            filterValues.includes(this.getFieldData(jsonData, filterKey)) &&
            jsonData.startsWith(checkForString)
          ) {
            return true
          }
        }
        return false
      }
      else {
        //TO-DO: Logic if filter is null
      }
    }
  }

  public static stringLength(value: string) {
    return value.length
  }

  public static contains(fieldValue: string, checkForString: string) {
    if (fieldValue === undefined || fieldValue === null) {
      return false
    }
    else if (fieldValue.includes(checkForString)) {
      return true
    } else {
      return false
    }
  }

  public static concat(value1: string, value2: string) {
    return value1.concat(value2)
  }

  public static string(value: any) {
    return value.toString()
  }

  public static uppercase(value: string) {
    return value.toUpperCase()
  }

  public static stringJoin(value: any, separator: string) {
    return Array.isArray(value) && value.every((item) => typeof item === 'string')
      ? value.filter((item) => item !== '').join(separator)
      : null
  }

  //#endregion for string functions

  public static abs(value: number) {
    return Math.abs(value)
  }

  public static boolean(value: boolean) {
    return value
  }

  public static notValuesMapSingleFrequency: Record<string, string> = {
    'billing.authorizationInformation.justificationForTransfer': 'billing.authorizationInformation.justificationForTransferPNNV',
    'billing.authorizationInformation.reasonForInterfacilityTransfer': 'billing.authorizationInformation.reasonForInterfacilityTransferPNNV',
    'billing.paymentInformation.primaryMethodOfPayment': 'billing.paymentInformation.primaryMethodOfPaymentPNNV',
    'ccHpiCardiacArrest.aedUse': 'ccHpiCardiacArrest.aedUsePNNV',
    'ccHpiCardiacArrest.arrestPresent': 'ccHpiCardiacArrest.arrestPresentPNNV',
    'ccHpiCardiacArrest.arrestResult': 'ccHpiCardiacArrest.arrestResultPNNV',
    'ccHpiCardiacArrest.defibBy': 'ccHpiCardiacArrest.defibByPNNV',
    'ccHpiCardiacArrest.destRhythm': 'ccHpiCardiacArrest.destRhythmPNNV',
    'ccHpiCardiacArrest.discReason': 'ccHpiCardiacArrest.discReasonPNNV',
    'ccHpiCardiacArrest.dtWitnessed': 'ccHpiCardiacArrest.dtWitnessedPNNV',
    'ccHpiCardiacArrest.dtCpr': 'ccHpiCardiacArrest.dtCprPNNV',
    'ccHpiCardiacArrest.dtDisc': 'ccHpiCardiacArrest.dtDiscPNNV',
    'ccHpiCardiacArrest.etiology': 'ccHpiCardiacArrest.etiologyPNNV',
    'ccHpiCardiacArrest.firstAedBy': 'ccHpiCardiacArrest.firstAedByPNNV',
    'ccHpiCardiacArrest.firstCpr': 'ccHpiCardiacArrest.firstCprPNNV',
    'ccHpiCardiacArrest.initialRhythm': 'ccHpiCardiacArrest.initialRhythmPNNV',
    'ccHpiCardiacArrest.cprType': 'ccHpiCardiacArrest.cprTypePNNV',
    'ccHpiCardiacArrest.resuscitation': 'ccHpiCardiacArrest.resuscitationPNNV',
    'ccHpiCardiacArrest.returnCirculation': 'ccHpiCardiacArrest.returnCirculationPNNV',
    'ccHpiCardiacArrest.whoWitnessed': 'ccHpiCardiacArrest.whoWitnessedPNNV',
    'ccHpiInjuryDetails.injurycause': 'ccHpiInjuryDetails.injurycausePNNV',
    'ccHpiInjuryDetails.fallHeight': 'ccHpiInjuryDetails.fallHeightPNNV',
    'ccHpiInjuryDetails.mechanism': 'ccHpiInjuryDetails.mechanismPNNV',
    'ccHpiInjuryDetails.safetyEquipment': 'ccHpiInjuryDetails.safetyEquipmentPNNV',
    'ccHpiInjuryDetails.traumaTriageCriteriaHighRisk': 'ccHpiInjuryDetails.traumaTriageCriteriaHighRiskPNNV',
    'ccHpiInjuryDetails.traumaTriageCriteriaModerateRisk': 'ccHpiInjuryDetails.traumaTriageCriteriaModerateRiskPNNV',
    'ccHpiInjuryDetails.workrelated': 'ccHpiInjuryDetails.workrelatedPNNV',
    'completeChart.cmsSvcLevel': 'completeChart.cmsSvcLevelPNNV',
    'crew.roles': 'crew.rolesPNNV',
    'crew.user': 'crew.userPNNV',
    'diagnosis.anatomicLocation': 'diagnosis.anatomicLocationPNNV',
    'diagnosis.finalPatientAcuity': 'diagnosis.finalPatientAcuityPNNV',
    'diagnosis.initialPatientAcuity': 'diagnosis.initialPatientAcuityPNNV',
    'diagnosis.organSystems': 'diagnosis.organSystemsPNNV',
    'dispatchId': 'dispatchIdPNNV',
    'disposition.addlTransportModeDescriptors': 'disposition.addlTransportModeDescriptorsPNNV',
    'disposition.hospitalCapability': 'disposition.hospitalCapabilityPNNV',
    'disposition.hospitalInPatientDestination': 'disposition.hospitalInPatientDestinationPNNV',
    'disposition.reasonForChoosingDestination': 'disposition.reasonForChoosingDestinationPNNV',
    'disposition.transportModeFromScene': 'disposition.transportModeFromScenePNNV',
    'disposition.destination.txToCode.name': 'disposition.destination.txToCode.namePNNV',
    'disposition.destination.state': 'disposition.destination.statePNNV',
    'disposition.destination.county': 'disposition.destination.countyPNNV',
    'disposition.destination.zip': 'disposition.destination.zipPNNV',
    'disposition.destination.txToCode': 'disposition.destination.txToCodePNNV',
    'factorsAffectingCareState.dispatchFactors': 'factorsAffectingCareState.dispatchFactorsPNNV',
    'factorsAffectingCareState.responseFactors': 'factorsAffectingCareState.responseFactorsPNNV',
    'factorsAffectingCareState.sceneFactors': 'factorsAffectingCareState.sceneFactorsPNNV',
    'factorsAffectingCareState.transportFactors': 'factorsAffectingCareState.transportFactorsPNNV',
    'factorsAffectingCareState.turnAroundFactors': 'factorsAffectingCareState.turnAroundFactorsPNNV',
    'history.drugalcIndicators': 'history.drugalcIndicatorsPNNV',
    'patient.narrative.narrativeText': 'patient.narrative.narrativeTextPNNV',
    'patient.narrative.hpi': 'patient.narrative.hpiPNNV',
    'patient.patientAllergies.allergies': 'patient.patientAllergies.allergiesPNNV',
    'patient.patientDemographics.barriersToCare': 'patient.patientDemographics.barriersToCarePNNV',
    'patient.patientDemographics.dnr': 'patient.patientDemographics.dnrPNNV',
    'patient.patientDemographics.dOB': 'patient.patientDemographics.dOBPNNV',
    'patient.patientDemographics.age': 'patient.patientDemographics.agePNNV',
    'patient.patientDemographics.ageUnit': 'patient.patientDemographics.ageUnitPNNV',
    'patient.patientDemographics.county': 'patient.patientDemographics.countyPNNV',
    'patient.patientDemographics.state': 'patient.patientDemographics.statePNNV',
    'patient.patientDemographics.zipCode': 'patient.patientDemographics.zipCodePNNV',
    'patient.patientDemographics.firstName': 'patient.patientDemographics.firstNamePNNV',
    'patient.patientDemographics.gender': 'patient.patientDemographics.genderPNNV',
    'patient.patientDemographics.sex': 'patient.patientDemographics.sexPNNV',
    'patient.patientDemographics.lastName': 'patient.patientDemographics.lastNamePNNV',
    'patient.patientDemographics.race': 'patient.patientDemographics.racePNNV',
    'patient.patientDemographics.triageColor': 'patient.patientDemographics.triageColorPNNV',
    'patient.patientDemographics.weight': 'patient.patientDemographics.weightPNNV',
    'patient.patientMedicalHistory.medicalHistoryIcdNemsisBasic': 'patient.patientMedicalHistory.medicalHistoryPNNV',
    'patient.patientMedications.patientMedicationsList': 'patient.patientMedications.patientMedicationPNNV',
    'patient.pickupAddress.city': 'patient.pickupAddress.cityPNNV',
    'patient.pickupAddress.state': 'patient.pickupAddress.statePNNV',
    'patient.pickupAddress.zip': 'patient.pickupAddress.zipPNNV',
    'patient.pickupAddress.county': 'patient.pickupAddress.countyPNNV',
    'patient.pickupAddress.modeDescriptors': 'patient.pickupAddress.modeDescriptorsPNNV',
    'patient.pickupAddress.otherType': 'patient.pickupAddress.otherTypePNNV',
    'patient.pickupAddress.milePostMajorRoadway': 'patient.pickupAddress.milePostMajorRoadwayPNNV',
    'patient.pickupAddress.addressLine1': 'patient.pickupAddress.addressLine1PNNV',
    'patient.pickupAddress.aptSuiteRoom': 'patient.pickupAddress.aptSuiteRoomPNNV',
    'patient.pickupAddress.crossStreetDirections': 'patient.pickupAddress.crossStreetDirectionsPNNV',
    'patient.tripInformation.crewDisposition': 'patient.tripInformation.crewDispositionPNNV',
    'patient.tripInformation.emdPerformed': 'patient.tripInformation.emdPerformedPNNV',
    'patient.tripInformation.massCasualty': 'patient.tripInformation.massCasualtyPNNV',
    'patient.tripInformation.patientEvaluation': 'patient.tripInformation.patientEvaluationPNNV',
    'patient.tripInformation.transportDisposition': 'patient.tripInformation.transportDispositionPNNV',
    'patient.tripInformation.unit.nemsis3_transport_method': 'patient.tripInformation.unit.nemsis3_transport_methodPNNV',
    'prNabc.broselow': 'prNabc.broselowPNNV',
    'prNabc.dtBaselineSeen': 'prNabc.dtBaselineSeenPNNV',
    'prNabc.strokeCvaSymptomsResolved': 'prNabc.strokeCvaSymptomsResolvedPNNV',
    'sceneDescription.firstOnScene': 'sceneDescription.firstOnScenePNNV',
    'sceneDescription.levelCarePerProtocol': 'sceneDescription.levelCarePerProtocolPNNV',
    'sceneDescription.numPtsScene': 'sceneDescription.numPtsScenePNNV',
    'sceneDescription.transferOfCare': 'sceneDescription.transferOfCarePNNV',
    'situation.patientActivity': 'situation.patientActivityPNNV',
    'situation.possibleInjury': 'situation.possibleInjuryPNNV',
    'times.arriveReceivingDate': 'times.arriveReceivingDateTimePNNV',
    'times.atPatientDate': 'times.atPatientDateTimePNNV',
    'times.enRouteDate': 'times.enRouteDateTimePNNV',
    'times.leaveReferringDate': 'times.leaveReferringDateTimePNNV',
    'times.onSceneDate': 'times.onSceneDateTimePNNV',
    'times.onsetDate': 'times.onsetDateTimePNNV',
    'times.receivedDate': 'times.receivedDateTimePNNV',
    'times.transferCareDestinationDate': 'times.transferCareDestinationDateTimePNNV',
    'times.transferCareEMSDate': 'times.transferCareEMSDateTimePNNV'
  }

  public static notValuesMapMultipleFrequency: Record<string, string> = {
    'exposure.exposureList.exposureType': 'exposure.exposureList.exposureTypePNNV',
    'exposure.exposureList.suspectedExposure': 'exposure.exposureList.suspectedExposurePNNV',
    'patient.hospitalNotifyStateList.alertType': 'patient.hospitalNotifyStateList.alertTypePNNV',
    'patient.intubationStateListNemsis.confirmationGroup.date': 'patient.intubationStateListNemsis.confirmationGroup.datePNNV',
    'patient.intubationStateListNemsis.confirmationGroup.method': 'patient.intubationStateListNemsis.confirmationGroup.methodPNNV',
    'patient.intubationStateListNemsis.confirmationGroup.distance': 'patient.intubationStateListNemsis.confirmationGroup.distancePNNV',
    'patient.intubationStateListNemsis.confirmationGroup.verifiedBy': 'patient.intubationStateListNemsis.confirmationGroup.verifiedByPNNV',
    'patient.intubationStateListNemsis.confirmationGroup.assessedBy': 'patient.intubationStateListNemsis.confirmationGroup.assessedByPNNV',
    'patient.intubationStateListNemsis.confirmationGroup.verificationVia': 'patient.intubationStateListNemsis.confirmationGroup.verificationViaPNNV',
    'patient.intubationStateListNemsis.indications': 'patient.intubationStateListNemsis.indicationsPNNV',
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.doseUnit': 'patient.medicationAdministeredStateList.addMedicationAdministeredData.doseUnitPNNV',
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.medication': 'patient.medicationAdministeredStateListPNNVs.addMedicationAdministeredData.medicationPNNV',
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.response': 'patient.medicationAdministeredStateList.addMedicationAdministeredData.responsePNNV',
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.route': 'patient.medicationAdministeredStateList.addMedicationAdministeredData.routePNNV',
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.complications': 'patient.medicationAdministeredStateList.addMedicationAdministeredData.complicationsPNNV',
    'patient.medicationAdministeredStateList.addMedicationAdministeredData.dose': 'patient.medicationAdministeredStateList.addMedicationAdministeredData.dosePNNV',
    'patient.medicationAdministeredStateListPNNVs.addMedicationAdministeredData.medication': 'patient.medicationAdministeredStateListPNNVs.addMedicationAdministeredData.medicationPNNV',
    'patient.medicationAdministeredStateList.assessedBy': 'patient.medicationAdministeredStateList.assessedByPNNV',
    'patient.medicationAdministeredStateList.administeredByAnotherUnit': 'patient.medicationAdministeredStateList.administeredByAnotherUnitPNNV',
    'patient.medicationAdministeredStateList.date': 'patient.medicationAdministeredStateList.datePNNV',
    'patient.medicationAdministeredStateList.pta': 'patient.medicationAdministeredStateList.ptaPNNV',
    'patient.medicationAdministeredStateList.rolePerforming': 'patient.medicationAdministeredStateList.rolePerformingPNNV',
    'patient.patientVitals.bloodPressureMethod': 'patient.patientVitals.bloodPressureMethodPNNV',
    'patient.patientVitals.ecgType': 'patient.patientVitals.ecgTypePNNV',
    'patient.patientVitals.ecgTypeMethod': 'patient.patientVitals.ecgTypeMethodPNNV',
    'patient.patientVitals.gcsQualifier': 'patient.patientVitals.gcsQualifierPNNV',
    'patient.patientVitals.diastolicBP': 'patient.patientVitals.diastolicBPPNNV',
    'patient.patientVitals.spCO': 'patient.patientVitals.spCOPNNV',
    'patient.patientVitals.spo2': 'patient.patientVitals.spo2PNNV',
    'patient.patientVitals.pta': 'patient.patientVitals.ptaPNNV',
    'patient.patientVitals.systolicBP': 'patient.patientVitals.systolicBPPNNV',
    'patient.patientVitals.temperature': 'patient.patientVitals.temperaturePNNV',
    'patient.patientVitals.totalGCSScore': 'patient.patientVitals.totalGCSScorePNNV',
    'patient.patientVitals.thromScreen': 'patient.patientVitals.thromScreenPNNV',
    'patient.patientVitals.etCO2': 'patient.patientVitals.etCO2PNNV',
    'patient.patientVitals.eyeOpeningResponse': 'patient.patientVitals.eyeOpeningResponsePNNV',
    'patient.patientVitals.glucose': 'patient.patientVitals.glucosePNNV',
    'patient.patientVitals.heartRate': 'patient.patientVitals.heartRatePNNV',
    'patient.patientVitals.levelOfConsciousness': 'patient.patientVitals.levelOfConsciousnessPNNV',
    'patient.patientVitals.motorResponse': 'patient.patientVitals.motorResponsePNNV',
    'patient.patientVitals.pain': 'patient.patientVitals.painPNNV',
    'patient.patientVitals.respirationRate': 'patient.patientVitals.respirationRatePNNV',
    'patient.patientVitals.rhythm': 'patient.patientVitals.rhythmPNNV',
    'patient.patientVitals.strokeScale': 'patient.patientVitals.strokeScalePNNV',
    'patient.patientVitals.strokeScaleScoreTotal': 'patient.patientVitals.strokeScaleScoreTotalPNNV',
    'patient.patientVitals.verbalResponse': 'patient.patientVitals.verbalResponsePNNV',
    'patient.patientVitals.protocol': 'patient.patientVitals.protocolPNNV',
    'patient.procedureTypeStateList.date': 'patient.procedureTypeStateList.datePNNV',
    'patient.procedureTypeStateList.nemsisCode': 'patient.procedureTypeStateList.nemsisCodePNNV',
    'patient.procedureTypeStateList.pta': 'patient.procedureTypeStateList.ptaPNNV',
    'patient.procedureTypeStateList.response': 'patient.procedureTypeStateList.responsePNNV',
    'patient.procedureTypeStateList.rolePerforming': 'patient.procedureTypeStateList.rolePerformingPNNV',
    'patient.procedureTypeStateList.procedurePerformedByAnotherUnit': 'patient.procedureTypeStateList.procedurePerformedByAnotherUnitPNNV',
    'patient.procedureTypeStateList.airwayPlacementTechnique': 'patient.procedureTypeStateList.airwayPlacementTechniquePNNV',
    'patient.medicationAdministeredStateList.administeredByAnotherUnitPNNV': 'patient.medicationAdministeredStateList.administeredByAnotherUnitPNNV',
    'sceneDescription.otherAgencies.firstOnScene': 'sceneDescription.otherAgencies.firstOnScenePNNV',
    'situation.complaintGroup.complaint': 'situation.complaintGroup.complaintPNNV',
    'situation.complaintGroup.complaintType': 'situation.complaintGroup.complaintTypePNNV',
    'situation.complaintGroup.duration': 'situation.complaintGroup.durationPNNV',
    'situation.complaintGroup.durationUnit': 'situation.complaintGroup.durationUnitPNNV'
  }

  public static adjustLHSBasedOnRHSValue(lhsValue: any, rhsValue: any) {
    if (typeof rhsValue === 'number') {
      if(lhsValue === '' || lhsValue === undefined || lhsValue === null){
        lhsValue = null
      }
      else if (!isNaN(Number(lhsValue))){
        lhsValue = Number(lhsValue)
      }
    }

    return lhsValue
  }

  public static getAgencyIdForState(data: any, stateId: any) {
    let agencyId
    if (data.agencyNumber) {
      if (stateId === 'XSD') {
        agencyId = data.agencyNumber
      }
      else {
        agencyId = (data.agencyNumber[stateId]) ? data.agencyNumber[stateId] : ''
      }
    }
    else {
      agencyId = ''
    }
    data.agencyId = agencyId
    return data
  }

  private static getKeys(arrayToSearch: any) {
    const keys = new Set()
    return arrayToSearch.map((obj: any) => obj.key)
  }

  private static fetchResultForCorrelationID(data: any, keys: any, customResults01: any, checkForEmpty = false, checkForSingleOccurence = false) {
    let finalResult = true
    data.customDataMerged.stateResults.forEach((result: any) => {
      const keyToCompare = result['clientCorrelationId'].split('_')[1]
      if (keys.includes(keyToCompare)) {
        if (customResults01) {
          finalResult = finalResult && this.valueInList(data?.customDataMerged?.stateResults, customResults01, 'results?.valueText')
          if(checkForSingleOccurence && finalResult)
            return finalResult
        }
        else {
          if (!checkForEmpty) {
            finalResult = finalResult && this.fieldHasValue(data?.customDataMerged?.stateResults, 'results?.valueText', null, checkForEmpty, checkForSingleOccurence)
            if(checkForSingleOccurence && finalResult){
              return finalResult
            }
          }
          else {
            finalResult = finalResult && !this.fieldHasValue(data?.customDataMerged?.stateResults, 'results?.valueText')
            if(checkForSingleOccurence && finalResult){
              return finalResult
            }
          }
        }
      }
      else {
        finalResult = finalResult && false
      }
    })
    return finalResult
  }

  public static buildLogicForCorrelationID(data: any, customResults01: any, customResults02: string, checkForEmpty = false, checkForSingleOccurence = false) {
    /*
    1. Procedures=>Fetch keys within procedureTypeStateList
    2. compare keys with the keys contained in customDataMerged clientCorrelationId
    3. If true/found, we would dive-in to that index
    */
    if (
      (!data.customDataMerged ||
        !data.customDataMerged.stateResults ||
        !Array.isArray(data.customDataMerged.stateResults) ||
        data.customDataMerged.stateResults.length === 0) && !checkForEmpty
    ) {
      return false
    }
    if (customResults02.includes('eProcedures')) {
      if (
        !data.patient.procedureTypeStateList ||
        !Array.isArray(data.patient.procedureTypeStateList) ||
        data.patient.procedureTypeStateList.length === 0
      ) {
        return false
      } else {
        const keys = this.getKeys(data.patient.procedureTypeStateList)
        return this.fetchResultForCorrelationID(data, keys, customResults01, checkForEmpty, checkForSingleOccurence)
      }
    }
    else if (customResults02.includes('eMedications')) {
      if (
        !data.patient.medicationAdministeredStateList ||
        !Array.isArray(data.patient.medicationAdministeredStateList) ||
        data.patient.medicationAdministeredStateList.length === 0
      ) {
        return false
      } else {
        const keys = this.getKeys(data.patient.medicationAdministeredStateList)
        return this.fetchResultForCorrelationID(data, keys, customResults01, checkForEmpty, checkForSingleOccurence)
      }
    }
    else if (customResults02.includes('Vitals')) {
      if (
        !data.patient.patientVitals ||
        !Array.isArray(data.patient.patientVitals) ||
        data.patient.patientVitals.length === 0
      ) {
        return false
      } else {
        const keys = this.getKeys(data.patient.patientVitals)
        return this.fetchResultForCorrelationID(data, keys, customResults01, checkForEmpty, checkForSingleOccurence)
      }
    }
    else if (customResults02.includes('Exam')) {
      if (
        !data.additionalAssessment.bodySurveys ||
        !Array.isArray(data.additionalAssessment.bodySurveys) ||
        data.additionalAssessment.bodySurveys.length === 0
      ) {
        return false
      } else {
        const keys = this.getKeys(data.additionalAssessment.bodySurveys)
        return this.fetchResultForCorrelationID(data, keys, customResults01, checkForEmpty, checkForSingleOccurence)
      }
    }
    return false
  }

  public static integer(value: any) {
    return Math.floor(value)
  }

  public static transformCustomResultsPNNV(data: any) {
    const conditionsForTransform = data &&
      data.customDataMerged &&
      data.customDataMerged.stateResults &&
      Array.isArray(data.customDataMerged.stateResults) &&
      data.customDataMerged.stateResults.length > 0
    if (conditionsForTransform) {
      data.customDataMerged.stateResults.forEach((res: any) => {
        if (res.resultsPNNV) {
          if (res.resultsPNNV.nv.includes('-')) {
            res.resultsPNNV.nv = (res.resultsPNNV.nv.split('-')[1] - 1000).toString()
          }
          if (res.resultsPNNV.pn.includes('-')) {
            res.resultsPNNV.pn = (res.resultsPNNV.pn.split('-')[1] - 1000).toString()
          }
        }
      })
    }
    return data
  }

  public static buildLogicForCustomConfigurationForSomeOrEvery(
    data: any,
    preConditionDatapoint: any,
    preConditionValue: any,
    customResultElementToFetch: any,
    mainConditionDatapointFromCustomGroupElement: any,
    specificValueFromCustomGroupElement: any,
    datapointvalueToFetch: any,
    someOrEvery: any
  ) {
    let configValues: any
    if(mainConditionDatapointFromCustomGroupElement.includes('@CustomElementID')){
      configValues = data?.customConfigurationData?.find((g: any) => g['customElementId'] === specificValueFromCustomGroupElement)?.[datapointvalueToFetch]
    }
    else{
      configValues = data?.customConfigurationData?.find((g: any) => g[mainConditionDatapointFromCustomGroupElement] === specificValueFromCustomGroupElement)?.['customElementId']
    }
    
    if(!configValues) return true
    const resultsGroups = data?.customDataMerged?.stateResults ?? []
    if(resultsGroups.length === 0) return true
    
    const filteredResultsGroup = resultsGroups.filter((ele: any) => ele?.[preConditionDatapoint] === preConditionValue)
    if(filteredResultsGroup.length === 0) return true
     
    if(customResultElementToFetch.includes('.')){
      //In case of results.ValueText
      const keyParts = customResultElementToFetch.split('.')
      return filteredResultsGroup.every((ele: any) => {
        if(Array.isArray(ele?.[keyParts[0]])) {
          return ele?.[keyParts[0]].every((subEle: any) => configValues.some((val: any) => val.valueText === subEle?.[keyParts[1]]))
        }
        else {
          return configValues.some((val: any) => val.valueText === ele?.[keyParts[0]]?.[keyParts[1]])
        }
      })
    }

    return filteredResultsGroup.every((ele: any) => {
      ele = (Array.isArray(ele)) ? ele : [ele]
      return ele.every((a: any) => configValues.some((val: any)=> val.valueText === a?.[customResultElementToFetch]))
    })
  }


  public static buildLogicForCustomConfiguration(
    data: any,
    lhs: any,
    customGroupElement: any,
    customGroupElementValue: any,
    valueToFetchFromCustomConfig: any
  ) {
    let valueToCompare: any
    let result = false
    if (customGroupElement.includes('@CustomElementID')) {
      data.customConfigurationData.forEach((obj: any) => {
        if (obj['customElementId'] === customGroupElementValue) {
          valueToCompare = obj[valueToFetchFromCustomConfig]
        }
      })
      data.customDataMerged.stateResults.forEach((obj: any) => {
        if (Array.isArray(valueToCompare)) {
          if (valueToCompare.includes(obj[lhs])) {
            result = true
          }
        } else {
          result = obj[lhs] === valueToCompare
        }
      })
    } else {
      data.customConfigurationData.forEach((obj: any) => {
        if (obj[customGroupElement] === customGroupElementValue) {
          if (valueToFetchFromCustomConfig === '@CustomElementID') {
            valueToCompare = obj['customElementId']
          } else {
            valueToCompare = obj[valueToFetchFromCustomConfig]
          }
        }
      })
      data.customDataMerged.stateResults.forEach((obj: any) => {
        if (obj[lhs] === valueToCompare) {
          result = true
        }
      })
    }
    return result
  }

  public static concatenatePathValues(
    jsonData: any,
    destinationPath: string,
    pathsList: Array<string>
  ) {
    let concatValue = ''
    pathsList.forEach(path => {
      const pathValue = this.getFieldData(jsonData, path)
      if (pathValue)
        concatValue += pathValue + ' '
    })
    concatValue = concatValue.trimEnd()

    const pathSegments = destinationPath.split('.')
    let currentValue = jsonData
    for (const [i, pathSegment] of pathSegments.entries()) {
      if (i !== pathSegments.length - 1) {
        if (currentValue.hasOwnProperty(pathSegment)) {
          currentValue = currentValue[pathSegment]

          // TODO: Handle Array subpaths 
          // if (Array.isArray(currentValue) && currentValue.length > 0) {
          //   const subPathSegments = pathSegments.slice(i + 1).join('.')

          //   currentValue.forEach((element, i) => {
          //     currentValue[i] = concatValue
          //   })
          // }
        } else {
          currentValue[pathSegment] = {}
          currentValue = currentValue[pathSegment]
        }
      } else {
        currentValue[pathSegment] = concatValue
      }
    }
    return jsonData
  }

  public static assignPickupAddressType(jsonData: any) {
    if (jsonData.patient?.pickupAddress) {
      if (jsonData.patient?.pickupAddress?.typeValue?.id === 2) {
        jsonData.patient.pickupAddress.refCommonId = 24
      }
      else if (jsonData.patient?.pickupAddress?.typeValue?.id === 0) {
        jsonData.patient.pickupAddress.refCommonId = jsonData.patient.pickupAddress.otherType?.id
      }
      //otherwise (type=EMS), leave refCommonId empty/undefined
    }
    return jsonData
  }

  public static fillDestinationStateId(data: any) {
    let stateIdsArray: any = []
    let stateIdObj: any = {}

    if (data?.disposition?.destination) {
      stateIdsArray = data.disposition.destination.stateIds
      stateIdObj = stateIdsArray && stateIdsArray.length > 0 ? stateIdsArray.find((item: any) =>
        item.state === data.disposition.destination.state?.id
      ) : ''

      if (stateIdObj && stateIdObj.stateId) {
        data.disposition.destination.state_id = stateIdObj.stateId
      }
      else {
        data.disposition.destination.state_id = ''
      }
    }
    return data
  }

  static initialiseCrewRules(pcrData: any) {
    if (!pcrData || !Array.isArray(pcrData.crew)) return pcrData

    // Only up to 4 crew members
    for (let idx = 0; idx < 4; idx++) {
      const member = pcrData.crew[idx]
      if (member) {
        const { rolesPNNV, licensures, ...rest } = member // remove unnecessary properties e.g. licensures
        pcrData[`crew${idx}`] = rest
      }
    }

    return pcrData
  }

  public static copyPNNVFromPatientAllergies(data: any) {
    const allergiesPNNV = {
      id: undefined,
      name: '',
      nv: '',
      pn: ''
    }

    const checkCondition = data.patient &&
      data.patient.patientAllergies &&
      data.patient.patientAllergies.allergies &&
      Array.isArray(data.patient.patientAllergies.allergies) &&
      data.patient.patientAllergies.allergies.length > 0
    if (!checkCondition) return data
    else {
      const allergiesObj = data.patient.patientAllergies
      const index = allergiesObj.allergies.findIndex((item: any) => item.nemsisCode === '8801013')
      if (index !== -1) {
        const pnnvItem = allergiesObj.allergies.splice(index, 1)[0]
        allergiesPNNV.id = pnnvItem.nemsisCode
        allergiesPNNV.name = pnnvItem.name
        allergiesPNNV.nv = ''
        allergiesPNNV.pn = pnnvItem.nemsisCode.toString()

        if (!allergiesObj.allergiesPNNV) allergiesObj.allergiesPNNV = {}
        allergiesObj.allergiesPNNV = allergiesPNNV
      }
    }
    return data
  }

  public static createPatientAllergiesPNNVList (data: any) { 
    const checkCondition = data.patient &&
      data.patient.patientAllergies &&
      data.patient.patientAllergies.allergies &&
      Array.isArray(data.patient.patientAllergies.allergies) &&
      data.patient.patientAllergies.allergies.length > 0
    if (!checkCondition) return data
    else {
      const nemsisCodesToCheck = [8801013, 716186003]
      data.patient.patientAllergiesPnnvList = []
      data.patient.patientAllergies.allergies.forEach((pnnvItem: any) => {
        const currentCode = pnnvItem?.nemsisCode ? Number(pnnvItem.nemsisCode) : null
        if (currentCode !== null && nemsisCodesToCheck.includes(currentCode)) {
          data.patient.patientAllergiesPnnvList.push({
            value: currentCode.toString()
          })
        }
      })
    }
    return data
  }

  /**
   * Two rules in Alabama schematron combine every element and some element within the same condition.
   * Far easier to carry out the logic here and just have RulesEngine create a js that will call this 
   * funcition.
   */
  public static checkEveryElementAndSomeElementCombination(data: any, filterOnPTA = false): boolean {
    if (data?.patient?.patientVitals === undefined || data?.patient?.patientVitals.length === 0) {
      return true
    }

    let vitalsRecords = data.patient.patientVitals
    if (filterOnPTA) {
      vitalsRecords = vitalsRecords.filter((vitalsGroup: any) => vitalsGroup.pta === 1)
    }

    return vitalsRecords.every((vitalsRecord: any) => {
      const valNotAvlblForeVitals19: boolean = this.fieldHasValue(vitalsRecord.eyeOpeningResponse, 'id', null, true)
      const valNotAvlblForeVitals20: boolean = this.fieldHasValue(vitalsRecord.verbalResponse, 'id', null, true)
      const valNotAvlblForeVitals21: boolean = this.fieldHasValue(vitalsRecord.motorResponse, 'id', null, true)
      // Multi-occurrence, check for length
      const valNotAvlblForeVitals22: boolean = vitalsRecord.gcsQualifier === undefined || vitalsRecord.gcsQualifier.length === 0
      const valNotAvlblForeVitals23: boolean = this.fieldHasValue(vitalsRecord, 'totalGCSScore', null, true)

      const anyChildIsEmpty: boolean = valNotAvlblForeVitals19 || valNotAvlblForeVitals20 || valNotAvlblForeVitals21 || valNotAvlblForeVitals22 || valNotAvlblForeVitals23
      return anyChildIsEmpty
    })
  }


  public static operatorResultForMultiplicity(jsonData: any, arrayKey: string, operator: string, compareValue: any, checkForSingleOccurence = true) {
    if(!jsonData || (jsonData && Array.isArray(jsonData) && jsonData.length === 0)) 
      return false
    let keyParts
    if(arrayKey.includes('.')){
      keyParts = arrayKey.split('.')
    }
    for(let i=0; i < jsonData.length; i++){
      const element = jsonData[i]
      if(keyParts && keyParts.length >= 2){
        if(element[keyParts[0].replace('?','')] && Array.isArray(element[keyParts[0].replace('?','')])){
          const nestedElement = element[keyParts[0].replace('?','')]
          for(let j=0;j < nestedElement.length;j++){
            if(checkForSingleOccurence){
              if(this.getResultForComparison(nestedElement[j][keyParts[1]], compareValue, operator))
                return true
            }
            else {
              //TO-DO: Other logic for -All
            }
          }
        }
        else {
          if(element[keyParts[0].replace('?','')]){
            const nestedElement = element[keyParts[0].replace('?','')]
            if(checkForSingleOccurence){
              if(this.getResultForComparison(nestedElement[keyParts[1]], compareValue, operator))
                return true
            }
            else {
              //TO-DO: Other logic for -All
            }
          }
        }
      }
      else {
        const nestedElement = element[arrayKey]
        if(checkForSingleOccurence){
          if(this.getResultForComparison(nestedElement, compareValue, operator))
            return true
        }
        else {
          //Other logic for -All
        }
      }
    }
    return false
  }

  private static getResultForComparison(jsonValue: any, compareValue: any, operator: string) {
    const jsonValueNumber = Number(jsonValue)
    const compareValueNumber = Number(compareValue)
    if(!isNaN(jsonValueNumber) && !isNaN(compareValueNumber)){
      jsonValue = jsonValueNumber
      compareValue = compareValueNumber
    }
    switch(operator){
      case 'GREATER_THAN':
        return jsonValue > compareValue
      case 'GREATER_THAN_OR_EQUAL':
        return jsonValue >= compareValue
      case 'LESS_THAN':
        return jsonValue < compareValue
      case 'LESS_THAN_OR_EQUAL':
        return jsonValue <= compareValue
      default:
        return false
    }
  }

  public static CreateWastedMedicationList(data: any) {
    data.patient.wastedMedicationsList = []

    if (data?.patient?.medicationAdministeredStateList?.length > 0) {
      data.patient.medicationAdministeredStateList.forEach((item: any) => {
        item.addMedicationAdministeredData.forEach((medication: any, index: number) => {
          if (medication.wasted === true) {
            data.patient.wastedMedicationsList.push(medication)
            delete item.addMedicationAdministeredData[index]
          }
        })
      })
    }
    return data
  }
  public static copyGuarantorInfoIntoInsurance(data: any) {
    // check if there is any insurance guarantor information at all
    const noInsured = data.billing?.insuranceInformation?.insuranceInformationList?.find((insuranceRecord: any) =>
      insuranceRecord.insured?.id !== undefined && insuranceRecord.insured?.id >= 0) === undefined
    // if not, exit now since there is no work to do
    if (noInsured === undefined || noInsured)
      return data

    // now check each insurance record to see if the guarantor is the patient or one of their relationships
    data.billing?.insuranceInformation?.insuranceInformationList?.forEach((insuranceRecord: any) => {
      // check for the patient as guarantor
      if (insuranceRecord.insured?.id === 0) {
        insuranceRecord.guarantorFname = data.patient?.patientDemographics?.firstNameOrPNNV
        insuranceRecord.guarantorMname = data.patient?.patientDemographics?.middleInitial
        insuranceRecord.guarantorLname = data.patient?.patientDemographics?.lastNameOrPNNV
        insuranceRecord.guarantorSsn = data.patient?.patientDemographics?.sSN
        insuranceRecord.guarantorDob = data.patient?.patientDemographics?.dOB
        insuranceRecord.guarantorPhone = data.patient?.patientDemographics?.phoneDetails?.[0]?.number
        // no relationship value since patient=guarantor
      }
      // check for an ID in the relationships list
      else if (insuranceRecord.insured?.id > 0) {
        const guarantor = data.billing?.relationshipsAndGuarantors?.relationshipsAndGuarantorsList?.find((relationship: any) =>
          relationship.key === insuranceRecord.insured.id.toString())

        // the guarantor should always exist since the UI shouldn't have let you put it in the insurance record otherwise,
        // but still good to double check first
        if (guarantor) {
          insuranceRecord.guarantorFname = guarantor.firstName
          insuranceRecord.guarantorMname = guarantor.middleInitial
          insuranceRecord.guarantorLname = guarantor.lastName
          insuranceRecord.guarantorRelationship = guarantor.relationship?.id
          insuranceRecord.guarantorSsn = guarantor.ssn
          insuranceRecord.guarantorDob = guarantor.dob
          // no phone number in the UI currently
        }
      }
    })
    return data
  }

  public static addDefaultTimeToDateOnlyFields(data: any) {
    if (data.additionalAssessment?.obstetrics?.expectedDateOfConfinement)
      data.additionalAssessment.obstetrics.expectedDateOfConfinement = data.additionalAssessment.obstetrics.expectedDateOfConfinement.trimEnd() + ' 00:00'
    if (data.additionalAssessment?.obstetrics?.lastMenstrualPeriod)
      data.additionalAssessment.obstetrics.lastMenstrualPeriod = data.additionalAssessment.obstetrics.lastMenstrualPeriod.trimEnd() + ' 00:00'

    return data
  }

  public static addVersionAndPTAForVentilatorProcedure(data: any){
    if(!data?.patient?.ventilatorStateList || data?.patient?.ventilatorStateList.length === 0) return data

    data.patient.ventilatorStateList.forEach((element: any) => {
      element.ventilatorPta = 0
      element.version = 2
    })
    return data
  }

  public static populateSignatureData(data: any) {
    if (data.signatures === undefined)
      return data
    
    data.signatures.unableToSignReason = ''
    data.signatures.sectionHeaderText = ''
    data.signatures.signatoryName = ''
    data.signatures.signatoryAddress = ''
    data.signatures.signatoryPhone = ''
    data.signatures.signatureDate = []

    if (data?.signatures?.chips[0]?.id === 1) {
      data.signatures.signatureSection = 1
      data.signatures.sectionHeaderText = data.signatures.sectionIHeaderText
      data.signatures.signatoryName = data.signatures.witnessPrintedName
      data.signatures.signatoryAddress = data.signatures.witnessAddress
      data.signatures.signatoryPhone = data.signatures.witnessPhone
      data.signatures.updatedTerms = data.signatures.sectionIHeaderText
      data.signatures.signatureDate.push({ date: data.signatures.ambulanceSignatureDt })
      data.signatures.signatureDate.push({ date: data.signatures.patientSignatureDt })
      data.signatures.signatureDate.push({ date: data.signatures.witnessSignatureDt })
    } else if (data?.signatures?.chips[0]?.id === 2) {
      data.signatures.signatureSection = 2
      data.signatures.sectionHeaderText = data.signatures.sectionIIHeaderText
      data.signatures.signatoryName = data.signatures.representativePrintedName
      data.signatures.signatoryAddress = data.signatures.representativeAddress
      data.signatures.signatoryPhone = data.signatures.representativePhone
      data.signatures.updatedTerms = data.signatures.sectionIIHeaderText
      data.signatures.unableToSignReason = data.signatures.sectionTwoReasonIncapableOfSigning
      data.signatures.signatureDate.push({ date: data.signatures.representativeSignatureDt })
    } else if (data?.signatures?.chips[0]?.id === 3) {
      data.signatures.signatureSection = 3
      data.signatures.sectionHeaderText = data.signatures.sectionIIIHeaderText
      data.signatures.signatoryName = data.signatures.receivingFacilityPrintedName
      data.signatures.updatedTerms = data.signatures.sectionIIIHeaderText
      data.signatures.unableToSignReason = data.signatures.sectionThreeReasonIncapableOfSigning
      data.signatures.signatureDate.push({ date: data.signatures.crewSignatureDt })
      data.signatures.signatureDate.push({ date: data.signatures.receivingFacilitySignatureDt })
    }

    return data
  }

  private static extractLicensureDetails(licensures: any): FlatOutput {
    if (!licensures) {
      return { id: undefined, stateId: undefined, type: undefined }
    }

    const entries = Object.entries(licensures)
    const stateLicenseEntry = entries.find(([key, value]) => (value as SourceLicensureDetail).type)
    const allDetails = Object.values(licensures) as SourceLicensureDetail[]
    const LicensureLevelData = allDetails.find(d => d.id)

    return {
      id: LicensureLevelData?.id,
      stateId: stateLicenseEntry ? (stateLicenseEntry[1] as SourceLicensureDetail).id : undefined,
      type: stateLicenseEntry ? stateLicenseEntry[0] : undefined
    }
  }

  public static populateCrewLicensuresData(data: any) {
    data.crew.forEach((crewMember: any, index: number) => {
      const crewDest = data[`crew${index}`]
      if (!crewMember || !crewDest) { return }

      const extracted = this.extractLicensureDetails(crewMember.licensures)

      if (!crewDest.licensures) {
        crewDest.licensures = {}
      }

      crewDest.licensures.id = extracted.id || ''
      crewDest.licensures.stateID = extracted.stateId || ''
      crewDest.licensures.type = extracted.type || ''
    })

    return data
  }

  public static populateCrewRolesData(data: any) {
    data.crewPrimaryCaregiverTransport = []
    data.crewPrimaryCaregiverScene = []
    data.crewDriverPilotTransport = []
    data.crewDriverPilotResponse = []

    data.crew.forEach((crewMember: any) => {
      if (!crewMember) { return }
      crewMember.roles.forEach((role: any) => {
        if (role.id === 6) {
          data.crewPrimaryCaregiverTransport.push({ id: crewMember.user.id })
        }
        if (role.id === 5) {
          data.crewPrimaryCaregiverScene.push({ id: crewMember.user.id })
        }
        if (role.id === 2) {
          data.crewDriverPilotTransport.push({ id: crewMember.user.id })
        }
        if (role.id === 1) {
          data.crewDriverPilotResponse.push({ id: crewMember.user.id })
        }
      })
    })

    return data
  }

  public static countOfProcedures (data: any){
    if(!data?.patient?.allCombinedProcedures || data?.patient?.allCombinedProcedures.length === 0) 
      data.patient.countOfProcedures = null
    else
      data.patient.countOfProcedures = data.patient.allCombinedProcedures.length

    return data
  }

  public static inutbationAbandonedAndDecisionDateAndType (data: any) {
    if(!data?.patient?.intubationStateList || data?.patient?.intubationStateList.length === 0) return data

    else {
      for(let i=0; i < data.patient.intubationStateList.length; i++){
        const id = i % 2 + 1
        if(id === 1){
          if(data.patient.intubationStateList[i].decisiontoManageDate && data.patient.intubationStateList[i].decisiontoManageTime){
            data.patient.intubationStateList[i].decisionDateType = id
            data.patient.intubationStateList[i].abandonedAndDecisionDate = data.patient.intubationStateList[i].decisiontoManageDate
            data.patient.intubationStateList[i].abandonedAndDecisionTime = data.patient.intubationStateList[i].decisiontoManageTime

          }
          else {
            data.patient.intubationStateList[i].decisionDateType = null
            data.patient.intubationStateList[i].abandonedAndDecisionDate = null
            data.patient.intubationStateList[i].abandonedAndDecisionTime = null
          }
        }
        else {
          if(data.patient.intubationStateList[i].abandonedDate && data.patient.intubationStateList[i].abandonedTime){
            data.patient.intubationStateList[i].decisionDateType = id
            data.patient.intubationStateList[i].abandonedAndDecisionDate = data.patient.intubationStateList[i].abandonedDate
            data.patient.intubationStateList[i].abandonedAndDecisionTime = data.patient.intubationStateList[i].abandonedTime
          }
          else {
            data.patient.intubationStateList[i].decisionDateType = null
            data.patient.intubationStateList[i].abandonedAndDecisionDate = null
            data.patient.intubationStateList[i].abandonedAndDecisionTime = null
          }
        }
      }
    }
  }
  public static setBurnsAssessmentMethod(data: any) {
    if (!data?.additionalAssessment?.burns) return data
    else {
      let burnsMethod = 'None'
      const isTBSA = data.additionalAssessment.burns.isTBSA
      if (isTBSA === 1) {
        burnsMethod = 'TBSA'
      }
      else if (isTBSA === 0) {
        burnsMethod = 'Rule of 9\'s'
      }

      data.additionalAssessment.burns.method = burnsMethod
    }
  }
  public static flattenAssessmentData(data: any) {
    const flattenBodySurveys: any[] = []
    data.additionalAssessment ??= {}
    if (!Array.isArray(data.additionalAssessment.bodySurveys)) {
      data.additionalAssessment.bodySurveys = []
    }
    
    // Assessment list mapping — locationId sets per assessment
    const assessmentList: Record<string, number[]> = {
      skinAssessment: [1],
      headAssessment: [2],
      faceAssessment: [3],
      neckAssessment: [4],
      heartAssessment: [6],
      abdomenGroupAssessment: [7, 14, 15, 16, 17, 18, 19, 85],
      pelvisOrGenitourinaryAssessment: [8],
      spineGroupAssessment: [9, 84, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 107, 108],
      extremityGroupAssessment: [10, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 86, 87, 93, 94, 95, 96, 88, 89],
      eyeGroupAssessment: [11, 32, 33, 34],
      lungGroupAssessment: [90, 91, 92, 97],
      chestGroupAssessment: [98, 99, 100, 101, 102, 103, 104, 105, 106],
      mentalStatusAssessment: [12],
      neurologicalAssessment: [13]
    }

    data.additionalAssessment.bodySurveys.forEach((a: any) => {
      const flattenedItem: any = {
        seq: a.seq,
        assessDt: a.assessDt,
      }

      Object.entries(assessmentList).forEach(([assessmentName, locationIds]) => {
        const filteredExamValues = (a.examValues || []).filter((e: any) =>
          locationIds.includes(e.locationId)
        )
        const filteredExamValuesPNNVs = (a.examValuesPNNVs || []).filter((e: any) =>
          locationIds.includes(e.locationId)
        )
        const filteredFindings = (a.findings || []).filter((f: any) =>
          locationIds.includes(f.locationId)
        )
        if (
          filteredExamValues.length || filteredExamValuesPNNVs.length || filteredFindings.length
        ) {
          const locationIdAll = [
            ...filteredExamValues.map((e: any) => e.locationId),
            ...filteredExamValuesPNNVs.map((e: any) => e.locationId),
            ...filteredFindings.map((f: any) => f.locationId),]
          const uniqueLocationIds = Array.from(new Set(locationIdAll))
          flattenedItem[assessmentName] = {
            examValues: filteredExamValues,
            examValuesPNNVs: filteredExamValuesPNNVs,
            findings: filteredFindings,
            locationIdAll: uniqueLocationIds
          }
        }
      })
      flattenBodySurveys.push(flattenedItem)
      data.additionalAssessment.flattenBodySurveys = flattenBodySurveys
    })
    return data
  }
  public static copyMethodToAction (data: any){
    if(!data?.patient?.excludedMedicationAdministeredAndMedicalConsultProcedure || data?.patient?.excludedMedicationAdministeredAndMedicalConsultProcedure.length === 0) 
      return data

    for (let i = 0; i < data.patient.excludedMedicationAdministeredAndMedicalConsultProcedure.length; i++){
      if(!data.patient.excludedMedicationAdministeredAndMedicalConsultProcedure[i].action && data.patient.excludedMedicationAdministeredAndMedicalConsultProcedure[i].method){
        data.patient.excludedMedicationAdministeredAndMedicalConsultProcedure[i].action = data.patient.excludedMedicationAdministeredAndMedicalConsultProcedure[i].method
      }
    }
    return data
  }
  public static convertAgeToYears(data: any) {
    const DAYS_IN_YEAR = 365.25
    const MONTHS_IN_YEAR = 12

    const age = data?.patient?.patientDemographics?.age
    const ageUnit = data?.patient?.patientDemographics?.ageUnit?.id?.toLowerCase()

    if (age === undefined || age === null || age === '' || !ageUnit) {
      data.patient.patientDemographics.yearConvert = ''
      return data
    }

    const parsedAge = parseFloat(age)
    if (isNaN(parsedAge)) {
      data.patient.patientDemographics.yearConvert = ''
      return data
    }

    let yearConvert: number | string = ''

    switch (ageUnit) {
      case 'd':
        yearConvert = parsedAge / DAYS_IN_YEAR
        break
      case 'm':
        yearConvert = parsedAge / MONTHS_IN_YEAR
        break
      case 'y':
        yearConvert = parsedAge
        break
      case 'h':
      default:
        yearConvert = ''
        break
    }

    data.patient.patientDemographics.yearConvert =
      typeof yearConvert === 'number' ? +yearConvert.toFixed(5) : yearConvert

    return data
  }
  public static parseDispatchedDateTime (data :any) {    
    if (data.times.dispatchedDate){
      const dispatchedDate = DateTime.fromFormat(`${data.times.dispatchedDate}`, 'MM/dd/yy')
      const weekdayValue = dispatchedDate.weekday
      const dispatchedDay = dispatchedDate.day

      let dayName

      if (weekdayValue >= 1){
        switch (weekdayValue){
          case 1:
            dayName = 'MON'
            break
          case 2:
            dayName = 'TUE'
            break
          case 3:
            dayName = 'WED'
            break
          case 4:
            dayName = 'THU'
            break
          case 5:
            dayName = 'FRI'
            break
          case 6:
            dayName = 'SAT'
            break
          case 7:
            dayName = 'SUN'
            break
          default:
            dayName = ''
        }
        data.dispatchedDayOfWeek = dayName
        data.dispatchedDayOfMonth = dispatchedDay
        return data
      }
    }
  }

  public static parseHourOfDispatchedTime(data :any){
    if (data.times.dispatchedTime){
      const hourOfDispatched = data.times.dispatchedTime.slice(0, 2)
      data.dispatchedHour = hourOfDispatched
      return data
    }
  }

  public static countOfAttachments(data: any){
    if(data._fileAttachments && data._fileAttachments.length > 0){
      data._fileAttachmentsCount = data._fileAttachments.length
    }
  }

  public static parseCustomAssessmentsFieldsByResponseType(data :any){
    if (data.patient?.assessmentsStateList?.length > 0) {
      data.patient.assessmentsStateList.forEach((assessment :any)  => {
        const booleanFields: any[] = []
        const picklistFields: any[] = []
        const picklistValues: any[] = []
        const serviceRosterFields: any[] = []

        assessment.customAssessmentsFields.forEach((assessmentField: any) => {
          const responseType :string = assessmentField.responseType
          if (responseType != null && responseType !== '') {
            if (responseType === 'Boolean - Yes/No') {
              booleanFields.push({fieldId: assessmentField.fieldId.toString(),
                value: assessmentField.value.id.toString()})
            }              
            else if (responseType === 'Checkbox/Multiselect' || responseType === 'Dropdown/Select List') {
              picklistFields.push({fieldId: assessmentField.fieldId.toString()})
              
              if (responseType === 'Checkbox/Multiselect')
                assessmentField.value.forEach((valueItem: any) => {
                  picklistValues.push({id: valueItem.id.toString()})
                })
              else 
                picklistValues.push({id: assessmentField.value.id.toString()})
            }           
            else if (responseType === 'Service Roster')
              serviceRosterFields.push({fieldId: assessmentField.fieldId.toString(), value: assessmentField.value.id.toString()})
          }        
        })
        assessment.customAssessmentsBooleanFields = booleanFields
        assessment.customAssessmentsPicklistFields = picklistFields
        assessment.customAssessmentPicklistValues = picklistValues
        assessment.customAssessmentsServiceRosterFields = serviceRosterFields      
      })}
    return data
  }

  public static getSystemCurrentDate (data: any){
    const now = DateTime.now()

    const date = now.toFormat('yyyy-MM-dd')
    const time = now.toFormat('HH:mm:ss')
    data.currentDate = date
    data.currentTime = time
    return data
  }

  public static checkValueInListAfterConversion (jsonData: any, targetConvertType: any, listArray: any){
    if(!listArray || !Array.isArray(listArray) || listArray.length === 0)
      return false
    let convertedValue
    switch (targetConvertType){
      case 'number':
        convertedValue = parseInt(jsonData)

      //Add other types as needed
    }
    if(Number.isNaN(convertedValue)) 
      return false
    else
      return listArray.includes(convertedValue)
  }

  public static countStandardSignatures(data: any) {
    let count = 0

    if (data?.signatures?.attachments && data?.signatures?.attachments.length > 0) {
      data.signatures.attachments.forEach((attachment: { key: string }) => {
        if (attachment.key.startsWith('StandardSignatures')) {
          count++
        }
      })
    }

    const standardSignatureCount = count
    data.standardSignaturesCount = count > 0 ? standardSignatureCount.toString() : null
    return data
  }

  public static countSkinAssessments(data: any) {
    let count = 0
    if (data?.additionalAssessment?.flattenBodySurveys?.length > 0) {
      data.additionalAssessment.flattenBodySurveys.forEach((assessment: any) => {
        if (assessment.skinAssessment)
          count++
      })
    }
    const SkinAssessmentCount = count > 0 ? count : null
    data.additionalAssessment.skinAssessmentCount = SkinAssessmentCount
    return data

  }

  public static combineMedicalHistoryData(data: any) {
    if (!data.patient?.patientMedicalHistory || !data.patient?.patientMedicalHistory?.medicalHistoryIcdNemsisBasic) {
      return data
    }
    if (!data.patient?.patientMedicalHistory?.medicalHistory) {
      data.patient.patientMedicalHistory.medicalHistory = []
    }
    data.patient.patientMedicalHistory.medicalHistory.push(...data.patient.patientMedicalHistory.medicalHistoryIcdNemsisBasic)
  }

  public static createAttachmentCategoryArray(data: any) {

    data.attachmentCategoryArray = []

    if (data?.signatures?.attachments && data?.signatures?.attachments.length > 0) {
      for (let i = 0; i < data.signatures.attachments.length; i++) {
        const signature = data.signatures.attachments[i]
        if (signature.key.startsWith('StandardSignatures')){
          data.attachmentCategoryArray.push({id: -5})
          break
        }
      }
    }

    if (data?._fileAttachments && data._fileAttachments.length > 0) {
      data._fileAttachments.forEach((attachment :any) => {
        data.attachmentCategoryArray.push({id: attachment.category.id})
      })
    }

    return data
  }

  public static createPatientPhoneDetailsDatapoint(data: any) {
    data.patient.patientDemographics.phoneDetailsOrPNNV = []
    if (data.patient?.patientDemographics?.phoneDetails?.length > 0) {
      data.patient.patientDemographics.phoneDetails.forEach((phone :any) => {        
        const phoneNumber = phone.number        
        if (phoneNumber && phoneNumber !== '')
          data.patient.patientDemographics.phoneDetailsOrPNNV.push({value: phone.number})
      })
    }
    const hasPhoneNumber :boolean = data.patient.patientDemographics.phoneDetailsOrPNNV.length > 0 ? true : false
    if (!hasPhoneNumber) {
      const pnnvName = data?.patient?.patientDemographics?.phoneDetailsPNNV?.name
      if (pnnvName && pnnvName !== '')
        data.patient.patientDemographics.phoneDetailsOrPNNV.push({value: pnnvName})
    }     
    return data
  }

  public static createEcgRhythmDatapoint(data: any) {
    if (data.patient?.patientVitals?.length > 0) {
      data.patient.patientVitals.forEach((vital: any) => {
        if (vital.rhythm?.length > 0){
          vital.ecgRhythmName = vital.rhythm[0].name
        }
      })
    }
  }

  public static checkForSomeNotEmptyElement(data:any){
    if(!data || !Array.isArray(data)){
      return false
    }
    const isAllPNNV = data.every ((obj: any) => Object.keys(obj).every(key => key.includes('PNNV')))

    return !isAllPNNV
  }

  public static createEmsResponseNumberWithPrid(data: any) {
    data.patient.tripInformation.emsResponseNumber = ''
    const isLocalId: boolean = this.checkLocalId(data)
    
    if (!isLocalId)
      data.patient.tripInformation.emsResponseNumber = data.pcrId
    else
      data.patient.tripInformation.emsResponseNumber = data?.patient?.tripInformation?.localId

    return data
  }

  public static createEmsResponseNumberWithLocalId(data: any) {
    data.patient.tripInformation.emsResponseNumber = ''
    data.patient.tripInformation.emsResponseNumber = data?.patient?.tripInformation?.localId

    return data
  }

  private static checkLocalId(data: any){
    const localId = data?.patient?.tripInformation?.localId
    return localId && localId !== ''
  }

  public static updatePatientMedicationsDose(data: any){    
    if (data.patient?.patientMedications?.patientMedicationsList?.length > 0) {      
      data.patient.patientMedications.patientMedicationsList.forEach((med: any) => {        
        if (med.dose != null && med.doseUnits != null) {
          med.dose = this.convertMedicationDose(med.dose, med.doseUnits.nemsisMultiplyFactor)
        }
      })
    }

    return data
  }

  public static copyInitialAssessmentToVitals(data: any) {
    const gcsEye = data?.prNabc?.gcsEye
    const gcsEyePNNV = data?.prNabc?.gcsEyePNNV
    const gcsVerbal = data?.prNabc?.gcsVerbal
    const gcsVerbalPNNV = data?.prNabc?.gcsVerbalPNNV
    const gcsMotor = data?.prNabc?.gcsMotor
    const gcsMotorPNNV = data?.prNabc?.gcsMotorPNNV
    const gcsTotal = data?.prNabc?.gcs
    const gcsTotalPNNV = data?.prNabc?.gcsPNNV
    const strokeScale = data?.prNabc?.strokeScale
    const strokeScalePNNV = data?.prNabc?.strokeScalePNNV
    const temperature = data?.prNabc?.cvTemp
    const temperatureMethod = data?.prNabc?.cvTempMethod
    const prGcsQualifier = data?.prGcsQualifier
    const prGcsQualifierPNNV = data?.prGcsQualifierPNNV

    if (
      !gcsEye && !gcsEyePNNV && !gcsVerbal && !gcsVerbalPNNV && !gcsMotor && !gcsMotorPNNV && gcsTotal == null && !gcsTotalPNNV &&
      !strokeScale && !strokeScalePNNV && temperature == null && !temperatureMethod &&
      (!prGcsQualifier || prGcsQualifier.length === 0) && !prGcsQualifierPNNV
    ) {
      return data
    }

    if (!data.patient) data.patient = {}
    if (!Array.isArray(data.patient.patientVitals)) {
      data.patient.patientVitals = []
    }

    let vitalDate = null
    let vitalTime = null
    let vitalNV = null

    const atPatientDate = data?.times?.atPatientDate
    const atPatientTime = data?.times?.atPatientTime
    const onSceneDate = data?.times?.onSceneDate
    const onSceneTime = data?.times?.onSceneTime

    if (atPatientDate && atPatientTime) {
      vitalDate = atPatientDate
      vitalTime = atPatientTime
    } else if (onSceneDate && onSceneTime) {
      vitalDate = onSceneDate
      vitalTime = onSceneTime
    } else {
      vitalNV = '7701001'
    }

    const initialAssessmentVital: any = {
      date: vitalDate,
      time: vitalTime,
      pta: true,
      dateTimePNNV: vitalNV ? { nv: vitalNV } : null,
      eyeOpeningResponse: gcsEye ? { ...gcsEye } : null,
      eyeOpeningResponsePNNV: gcsEyePNNV ? { ...gcsEyePNNV } : null,
      verbalResponse: gcsVerbal ? { ...gcsVerbal } : null,
      verbalResponsePNNV: gcsVerbalPNNV ? { ...gcsVerbalPNNV } : null,
      motorResponse: gcsMotor ? { ...gcsMotor } : null,
      motorResponsePNNV: gcsMotorPNNV ? { ...gcsMotorPNNV } : null,
      totalGCSScore: gcsTotal ?? null,
      totalGCSScorePNNV: gcsTotalPNNV ? { ...gcsTotalPNNV } : null,
      strokeScale: strokeScale ? { ...strokeScale } : null,
      strokeScalePNNV: strokeScalePNNV ? { ...strokeScalePNNV } : null,
      temperature: temperature ?? null,
      temperatureMethod: temperatureMethod ? { ...temperatureMethod } : null,
      gcsQualifier: Array.isArray(prGcsQualifier) ? [...prGcsQualifier] : [],
      gcsQualifierPNNV: prGcsQualifierPNNV ? { ...prGcsQualifierPNNV } : null
    }

    data.patient.patientVitals.push(initialAssessmentVital)

    return data
  }

  public static nemsisVersionBackwardCompatibility(data: any, targetVersion: string) {
    if (targetVersion === '3.5.0') {
      if (data.patient?.intubationStateListNemsis !== null && 
          data.patient?.intubationStateListNemsis?.airwayComplicationsPNNV?.pn === '8801015') {
        data.patient.intubationStateListNemsis.airwayComplicationsPNNV.pn = null
        data.patient.intubationStateListNemsis.airwayComplicationsPNNV.nv = '7701005' // set None Reported PN to Not Reporting NV
      }

      // PNs don't exist in 3.5.0 for dtWitnessed, so set entire object to null (NV won't be set if PN was) for auto-fill to put in NV later
      if (data.ccHpiCardiacArrest?.dtWitnessedPNNV?.pn) {
        data.ccHpiCardiacArrest.dtWitnessedPNNV = null
      }

      // PNs don't exist in 3.5.0 for patient race, so  set entire object to null (NV won't be set if PN was) for auto-fill to put in NV later
      if (data.patient?.patientDemographics?.racePNNV?.pn) {
        data.patient.patientDemographics.racePNNV = null
      }

      // PNs don't exist in 3.5.0 for patient age, so set entire object to null (NV won't be set if PN was) for auto-fill to put in NV later
      if (data.patient?.patientDemographics?.agePNNV?.pn) {
        data.patient.patientDemographics.agePNNV = null
      }
    }
    return data
  }

  public static copyPathToPath(data: any, srcPath: string, destPath: string) {
    const getValueAtPath = (obj: any, path: string): { value: any; exists: boolean } => {
      const segments = path.split('.')
      let current = obj
      for (const segment of segments) {
        if (current == null || typeof current !== 'object' || !(segment in current)) {
          return { value: undefined, exists: false }
        }
        current = current[segment]
      }
      return { value: current, exists: true }
    }

    const setValueAtPath = (obj: any, path: string, value: any) => {
      const segments = path.split('.')
      let current = obj
      for (let i = 0; i < segments.length - 1; i++) {
        if (current[segments[i]] == null || typeof current[segments[i]] !== 'object') {
          current[segments[i]] = {}
        }
        current = current[segments[i]]
      }
      current[segments[segments.length - 1]] = value
    }

    const src = getValueAtPath(data, srcPath)
    if (!src.exists) return data

    const dest = getValueAtPath(data, destPath)
    const srcArray = Array.isArray(src.value) ? src.value : [src.value]
    const destArray = dest.exists && Array.isArray(dest.value) ? dest.value : []
    setValueAtPath(data, destPath, [...destArray, ...srcArray])
    return data
  }

  public static defaultCustomDataForNJ(data: any) {
    const isBlsAllLevels = data?.sceneDescription?.levelCarePerProtocol?.nemsisCode === '4232001'   
    if (!isBlsAllLevels)
      return data
    
    const hasCustomData = data?.customData?.length > 0
    const hasBls911 = data.customdata?.some((item :any) => 
      item.stateResults?.results?.valueText === 'itResponse.115.102')

    if (hasCustomData && hasBls911)
      return data
    
    const defaultValue: IStateResult = {
      customElementId: 5914,
      customElementName: 'itResponse.115',
      clientCorrelationId: '',
      originalDataPath: '',
      groupingSequence: 1,
      groupCorrelation: '',
      elementNumber: '',
      version: '3.5.1',
      mapToNemsis3: 1,
      results: {
        id: -20950,
        name: 'BLS - Emergency Transport (911)',
        isPN: false,
        isNV: false,
        valueText: 'itResponse.115.102'
      },
      resultsPNNV: null,
      groupId: '',
      _groupKey: '51731711'
    }

    if (hasCustomData) {
      data.customData.some((item :any) => {
        if (item.state === 'NJ') 
          item.stateResults.push(defaultValue)
      })
    } else {
      const NJCustomDataObj = {
        state: 'NJ',
        StateResults: [defaultValue]
      }
      data.customData.push(NJCustomDataObj)
    }
    return data
  } 
}